// --- INLINE JAVASCRIPT: BYPASS ALL SHOPIFY CACHING ---
// ZURÜCK ZU VARIANTE A (DIREKT IN DEN WARENKORB LEGEN)

/* QUIZ-FIX-V9 (Ulrike 28.09., Joshua-Durchklick nach Hero-Test): Stufe 2/3 ohne Sackgassen.
   - Gratis-Seife: Varianten werden zur Laufzeit aufgeloest (ausverkauft/veraltete ID -> passende
     verfuegbare Variante); klappt ein Add trotzdem nicht, geht der Flow weiter statt "nochmal versuchen".
   - Nach "Box (+ Oel) in den Warenkorb" verschwindet das Ergebnis samt Oel-Wahl -> direkt zur Gratis-Seife.
   - Stufen-Chip zeigt die gewaehlte Stufe; Gratis-Seife ohne "Stufe 1".
   - CTAs ohne Emojis, Erfolgszustand gold/creme statt gruen; Stufe-3-Ausstiege fuehren zur Schale/Reisebox. */
var LQ_AOV_TAG = 'V2.3.1'; /* QUIZ-FIX-V231 (02.10.): Stufe-3-Preisblock */ /* QUIZ-AOV-V23: Theme-Kennung fuer die Quiz-Messung */
var LQ_CHECK = '<svg class="lq-check" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>';
window.__lqApplyTierChip = function () {
  var t = null;
  try { t = sessionStorage.getItem('loonaTierIntent'); } catch (e) {}
  t = t || window.__loonaTier || '1';
  var map = { '1': 'Stufe 1: deine Box', '2': 'Stufe 2: Box + Haaröl', '3': 'Stufe 3: dein komplettes Ritual' };
  if (!map[t]) t = '1';
  var num = document.getElementById('lq-tier-num');
  var txt = document.getElementById('lq-tier-text');
  if (num) num.textContent = t;
  if (txt) txt.textContent = map[t];
};

/* V7.2 (Joshua-Test 10.08.): Drawer-Live-Sync. Jeder Quiz-Add aktualisiert Mini-Cart +
   Zähl-Bubbles über die Section-Rendering-API — gleiche Section-Liste und gleicher
   Selektor wie renderContents() in assets/cart-drawer.js. Der Drawer wird bewusst NICHT
   aufgeklappt (mitten im Quiz), er ist beim nächsten Öffnen einfach aktuell. */
window.__loonaCartSync = function () {
  try {
    var ids = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
    fetch('/?sections=' + ids.join(','))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (sections) {
        if (!sections) return;
        ids.forEach(function (id) {
          var el = document.getElementById(id);
          if (!el || !sections[id]) return;
          var parsed = new DOMParser().parseFromString(sections[id], 'text/html').querySelector('.shopify-section');
          if (parsed) el.innerHTML = parsed.innerHTML;
        });
        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(function () {});
  } catch (e) {}
};

/* V7.2 (Joshua-Test 10.08.): Idempotenz über Seitenwechsel. Liegt die Box schon im
   Warenkorb (früherer Durchlauf/Reload), nimmt der Add-Button den Late-Pfad statt die
   Box zu doppeln; liegt das Öl schon drin, gilt die Öl-Wahl als getroffen (kein Re-Pitch). */
fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js')
  .then(function (r) { return r.json(); })
  .then(function (c) {
    var items = (c && c.items) || [];
    if (items.some(function (i) { return ((i.product_title || '').toLowerCase().indexOf('box') !== -1); })) {
      window.__loonaBoxAdded = true;
    }
    var cfgOil = (window.__loonaRitualConfig || {}).oilHandle;
    if (cfgOil && items.some(function (i) { return i.handle === cfgOil; })) {
      window.__loonaOilChoice = 'taken';
    }
  })
  .catch(function () {});

/* COMBO-BILD-OEL FIX 20.10.: Öl-Zeile merkt sich die Box (Property _lf_box = Box-Varianten-ID),
   damit der Warenkorb das Combo-Bild an genau dieser Box zeigt (lf-combo-bild.liquid, ctx 'cart'). */
window.__lfcOilItem = function (oilId, boxVid) {
  var it = { id: parseInt(oilId), quantity: 1 };
  if (boxVid) it.properties = { _lf_box: String(boxVid) };
  return it;
};
document.addEventListener('click', async function(e) {
  let addBtn = e.target.closest('.js-cart-quiz-add-btn');
  // BODY-RESET-V3-MARKER: Guard against double-add when user accidentally re-clicks
  if (addBtn && window.__loonaBoxAdded === true) {
    e.preventDefault();
    e.stopImmediatePropagation();
    // RITUAL-STUFEN-V6: Box ist schon im Cart — ein NACHTRÄGLICH aktiviertes Öl aber noch nicht.
    const lateOil = addBtn.getAttribute('data-oil-variant-id');
    if (lateOil && addBtn.getAttribute('data-oil-added') !== 'true') {
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [window.__lfcOilItem(lateOil, addBtn.getAttribute('data-variant-id'))] })
      }).then(r => {
        if (r.ok) {
          addBtn.setAttribute('data-oil-added', 'true');
          window.__loonaOilChoice = 'taken'; /* V7.2: Öl-Wahl ist bindend — kein Re-Pitch */
          if (typeof window.updateCartCount === 'function') window.updateCartCount();
          if (typeof window.__loonaCartSync === 'function') window.__loonaCartSync(); /* V7.2 */
        }
      }).catch(() => {});
    }
    if (typeof window.__triggerBodyBridge === 'function') window.__triggerBodyBridge();
    return;
  }
  if (addBtn) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const variantId = addBtn.getAttribute('data-variant-id');
    if(!variantId) return;
    // RITUAL-STUFEN-V6: Öl-Toggle am Box-Ergebnis → mittleres Bündel (Box + Öl) in EINEM Add
    const oilVariantId = addBtn.getAttribute('data-oil-variant-id');

    addBtn.style.opacity = "0.6";
    addBtn.style.pointerEvents = "none";
    const originalText = addBtn.innerHTML;
    addBtn.innerHTML = "Wird in den Warenkorb gelegt...";

    try {
      // BODY-RESET-V52-MARKER: pendingBodyCombo NUR lesen wenn aktuell im Body-First-Mode.
      // Vorher (V5.1): stale combo aus früherer Session führte zu Cart-Skip im Hair-First-Flow.
      let cartItems = [{ id: variantId, quantity: 1 }];
      if (oilVariantId) cartItems.push(window.__lfcOilItem(oilVariantId, variantId));
      let hadPendingCombo = false;
      const isBodyFirstActive = window.__bodyFirstMode === true;
      if (isBodyFirstActive) {
        const pendingComboRaw = (function(){
          try { return localStorage.getItem('pendingBodyCombo'); } catch(e) { return null; }
        })();
        if (pendingComboRaw) {
          try {
            const parsed = JSON.parse(pendingComboRaw);
            let comboArr = null;
            if (Array.isArray(parsed)) {
              comboArr = parsed; // legacy fallback
            } else if (parsed && parsed.variants && parsed.expiresAt) {
              if (Date.now() < parsed.expiresAt) {
                comboArr = parsed.variants;
              } else {
                try { localStorage.removeItem('pendingBodyCombo'); } catch(e) {}
              }
            }
            if (Array.isArray(comboArr) && comboArr.length > 0) {
              /* QUIZ-FIX-V9: Gratis-Seife vor dem Add aufloesen (ausverkaufte/veraltete ID riss sonst den Box-Add mit) */
              if (typeof window.__lqResolveSoapIds === 'function') { try { comboArr = await window.__lqResolveSoapIds(comboArr); } catch (e) {} }
              comboArr.forEach(vid => cartItems.push({ id: parseInt(vid), quantity: 1 }));
              hadPendingCombo = comboArr.length > 0;
            }
          } catch(e) {}
        }
      } else {
        // Defensiv: cleanup stale pendingBodyCombo wenn user nicht im Body-First-Mode
        try { localStorage.removeItem('pendingBodyCombo'); } catch(e) {}
      }
      const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: cartItems })
      });
      
      if (!res.ok && hadPendingCombo) {
        /* QUIZ-FIX-V9: Seife blockiert den Add -> Box (+ Oel) trotzdem legen, Seife danach ueber die Bridge */
        const lqRetry = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: cartItems.slice(0, oilVariantId ? 2 : 1) })
        });
        if (!lqRetry.ok) throw new Error("Add to cart failed");
        hadPendingCombo = false;
        window.__bodyFirstMode = false;
      } else if (!res.ok) throw new Error("Add to cart failed");

      /* V7.2: Öl war beim Add dabei → Wahl gemerkt (kein Re-Pitch); Drawer sofort aktuell. */
      if (oilVariantId) window.__loonaOilChoice = 'taken';
      window.__lfComboBox = String(variantId); /* COMBO-BILD-OEL FIX 20.10.: Box für späteres Öl (Öl-Schritt) */
      /* QUIZ-AOV-V23 (Ulrike 29.09.): Quiz-Bestellungen je Theme-Arm messbar machen. Unsichtbares Warenkorb-
         Attribut (steht nur in der Bestellung im Admin): Theme-Kennung | Stufe beim Add | Oel ja/nein | Box-Variante.
         Bisher liess sich eine Quiz-Bestellung nur ueber Elevate-Events (Warenkorb auf der Startseite) zuordnen. */
      try {
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { _lq_quiz: [LQ_AOV_TAG, 'St' + (window.__loonaTier || '1'), oilVariantId ? 'Oel' : 'ohneOel', 'v' + variantId].join('|') } })
        }).catch(function () {});
      } catch (e) {}
      if (typeof window.__loonaCartSync === 'function') window.__loonaCartSync();

      // BODY-RESET-V4-MARKER: Body-First-Flow → Combo war dabei.
      // RITUAL-STUFEN-V6: statt direkt zum Cart jetzt weiter zur Ritual-Stufe (Schale + Sisal).
      if (hadPendingCombo) {
        try { localStorage.removeItem('pendingBodyCombo'); } catch(e) {}
        addBtn.innerHTML = LQ_CHECK + 'Box + Körperseife im Warenkorb'; /* QUIZ-FIX-V9: gold/creme statt gruen */
        addBtn.classList.add('lq-done');
        addBtn.disabled = true;
        if (typeof window.updateCartCount === 'function') window.updateCartCount();
        const ritualCfg = window.__loonaRitualConfig || {};
        if (typeof window.__showOilStep === 'function') {
          setTimeout(() => window.__showOilStep(), 800);
        } else if (ritualCfg.ritualEnabled && typeof window.__showRitualStep === 'function') {
          setTimeout(() => window.__showRitualStep(), 800);
        } else {
          setTimeout(() => { window.location.href = window.Shopify.routes.root + "cart"; }, 800);
        }
        return;
      }
      
      // BODY-RESET-V3-MARKER: silent-mode + body-flow-trigger + double-add-guard
      const isBodyFlow = addBtn.getAttribute('data-body-quiz-flow') === 'true';
      window.__loonaBoxAdded = true; // Guard against double-add
      if (oilVariantId) addBtn.setAttribute('data-oil-added', 'true'); // RITUAL-STUFEN-V6
      if (isBodyFlow && typeof window.__triggerBodyBridge === 'function') {
        addBtn.innerHTML = LQ_CHECK + (oilVariantId ? 'Box + Öl im Warenkorb' : 'Box im Warenkorb'); /* QUIZ-FIX-V9 */
        addBtn.classList.add('lq-done');
        addBtn.disabled = true;
        if (typeof window.updateCartCount === 'function') window.updateCartCount();
        setTimeout(() => window.__triggerBodyBridge(), 600);
        return;
      }
      window.location.href = window.Shopify.routes.root + "cart";
    } catch (err) {
      console.error(err);
      addBtn.innerHTML = "Fehler aufgetreten.";
      addBtn.style.opacity = "1";
      addBtn.style.pointerEvents = "auto";
      setTimeout(() => { addBtn.innerHTML = originalText; }, 2000);
    }
    return;
  }

  // --- QUIZ TRIGGER GLOBALE ABFANG LOGIC ---
  let target = e.target;
  while (target && target !== document.body) {
    if (target.tagName === 'A' && target.getAttribute('href') && target.getAttribute('href').includes('#cart-quiz')) {
      // BODY-RESET-V5-MARKER: Click-Handler erkennt ?quiz=body im href
      const href = target.getAttribute('href');
      const isBodyFirstRequest = href.includes('quiz=body');
      // RITUAL-STUFEN-FIX (26.09.2026, Ulrike/Thomas): Stufen-Intent hier setzen. Dieser Capture-Handler stoppt die Propagation, der Klick-Listener in sections/ritual-stufen.liquid wird nie erreicht.
      const tierAttr = target.getAttribute('data-ritual-tier');
      window.__loonaTier = tierAttr || null; /* QUIZ-FIX-V9: Stufe merken (Chips + Stufe-3-Ausstiege) */
      if (tierAttr) { try { sessionStorage.setItem('loonaTierIntent', tierAttr); } catch (err) {} }
      e.preventDefault();
      e.stopImmediatePropagation(); // Verhindert Theme-internes Scrolling!
      if (typeof window.openCartQuiz === 'function') {
         window.openCartQuiz(e);
      } else {
         window.location.href = '/cart#cart-quiz';
      }
      // BODY-RESET-V5-MARKER: Body-First-Flow trigger NACH modal open
      if (isBodyFirstRequest) {
        window.__bodyFirstModeRequested = true;
        setTimeout(() => {
          if (typeof window.__triggerBodyFirstMode === 'function') {
            window.__triggerBodyFirstMode();
          }
        }, 300);
      }
      return;
    }
    target = target.parentNode;
  }
}, true);

// Auto-Open bei Navigation via URL Hash
document.addEventListener('DOMContentLoaded', () => {
    if(window.location.hash === '#cart-quiz') {
       setTimeout(() => {
          if (typeof window.openCartQuiz === 'function') {
             window.openCartQuiz();
          }
       }, 500);
    }
});

/* ====================================================================
   BODY-RESET-V52-MARKER · 15.06.2026 14:34 (variant-c only)
   Bug-Fix Joshua-Feedback 14:34:
   - Hair-First-Flow → keine Body-Bridge mehr nach Box-Add
   - Root-Cause: pendingBodyCombo aus früherer Body-First-Test-Session
     bleibt 30min in localStorage (V5.1 TTL) → hadPendingCombo=true
     im normalen Hair-Flow → direkter Cart-Redirect, kein Bridge.
   - Fix: pendingBodyCombo NUR lesen wenn __bodyFirstMode === true.
     Defensiv: cleanup stale combo wenn user nicht im Body-First-Mode.
   ==================================================================== */
/* ====================================================================
   BODY-RESET-V51-MARKER · 15.06.2026 14:26 (variant-c only)
   Deep Due Diligence Joshua-Feedback:
   - BUG-FIX #1: Hair-Quiz Click-Handler filtert data-quiz-step="body-X" aus
     (vorher: parseInt NaN → evaluateResult → falsches Hair-Match nach Body-F1)
   - BUG-FIX #2: resetQuiz cleart auch Body-Quiz state + flags
   - BUG-FIX #3: pendingBodyCombo bekommt 30min-TTL (kein Stale-Carry-Over)
   ==================================================================== */
/* ====================================================================
   BODY-RESET-V5-MARKER · 15.06.2026 14:09 (variant-c only)
   - Body-First-Flow Bug-Fix: Click-Handler erkennt ?quiz=body, ruft __triggerBodyFirstMode
   - GRATIS-Wording + Badge konditional zurück (Hair-First vs Body-First)
   - Box-CTA extra-strong gold forcing (background + background-color + border)
   ==================================================================== */
/* ====================================================================
   BODY-RESET-V4-MARKER · 15.06.2026 (variant-c only)
   - Promo neutral (kein GRATIS, kein Hair-Bezug)
   - Body-First-Flow: ?quiz=body + keine Box → Body-Quiz first → Hair-Quiz
   - Hair-Box-Add nimmt localStorage pendingBodyCombo mit
   - Smooth-Scroll von Box-CTA → Body-Bridge im Modal
   - GRATIS-Wording aus Body-Result entfernt (Discount regelt sich automatisch)
   ==================================================================== */
/* ====================================================================
   HAIR-QUIZ-V3.1-MARKER · Customer-Service-Optimierung 15.06.2026
   Basis: V3.0 (10.03.2026) + CS-Check-in 29.05.2026
   Quellen: LOONAS_Haar_Quiz_V3_1_OPTIMIERT.md, Fireflies 01KSHZ1AKS045AZHQHDXMSG8EQ
   Änderungen:
     - F1.G NEU: "haar_okay_umsteigen" → PURE DETOX +1 (Neutral-Anker)
     - F2.D Text-Update + data-neutral
     - F3.C Text-Update + data-neutral
     - F4.D / F5.C / F5.D / F6.E data-neutral
     - Tiebreaker 1b: F1.G → F4 → F5 → F6 (nächststärkstes Signal)
     - Empathy-Microcopy auf Ergebnisseite (Mehrfach-Persona Off-Ramp)
   ==================================================================== */
function initCartQuiz() {
  const quizModal = document.getElementById('cart-quiz-modal');
  if (!quizModal) return;

  const closeButtons = quizModal.querySelectorAll('[data-quiz-close]');
  const optionBtns = quizModal.querySelectorAll('.cart-quiz-option-btn');
  const loadingScreen = quizModal.querySelector('#cart-quiz-loading');
  const resultContainer = quizModal.querySelector('#cart-quiz-result-product');
  const resultMessage = quizModal.querySelector('#cart-quiz-result-message');

  let answers = { f1: '', f2: '', f3: '', f4: '', f5: '', f6: '' };
  let cartData = null;

  window.openCartQuiz = async function (e) {
    if (e) { e.preventDefault(); e.stopImmediatePropagation(); }
    quizModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden-mobile');
    resetQuiz();
    try {
      const c = await fetch(window.Shopify.routes.root + 'cart.js');
      cartData = await c.json();
    } catch (err) { }
  };

  // --- KUGELSICHERE SCHLIESS-LOGIK OHNE SCROLL-JUMPS ---
  const closeQuiz = function(e) {
    if (e) {
       e.preventDefault();
       e.stopPropagation();
    }
    
    // 1. ZUERST den Hash aus der URL entfernen, BEVOR wir den Body entsperren!
    if (window.location.hash.includes('cart-quiz')) {
       history.replaceState('', document.title, window.location.pathname + window.location.search);
    }

    // 2. Extra Sicherheit: Scroll-Position fixieren (besonders für iOS Safari)
    const currentScroll = window.scrollY;

    // 3. Dann erst Modal verstecken und Body entsperren
    quizModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden-mobile');

    // 4. Und den Browser zwingen, sofort wieder genau da zu bleiben, wo er war
    window.scrollTo({
      top: currentScroll,
      behavior: 'instant'
    });
  };

  closeButtons.forEach(btn => {
    btn.addEventListener('click', closeQuiz);
  });

  quizModal.addEventListener('click', (e) => {
    if (e.target.classList.contains('cart-quiz-modal') || e.target.classList.contains('cart-quiz-overlay')) {
      closeQuiz(e);
    }
  });

  const modalContent = quizModal.querySelector('.cart-quiz-content');
  if (modalContent) {
    modalContent.addEventListener('click', (e) => { e.stopPropagation(); });
  }

  optionBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      // BODY-RESET-V51-MARKER: BUG-FIX #1
      // Body-Quiz-Buttons haben data-quiz-step="body-1" etc. - die NICHT durchlassen.
      // parseInt('body-1') = NaN → wenn nicht früh return, läuft evaluateResult() (else-Zweig)
      // und rendert eine zufällige Haar-Box als Match → Joshua-Bug 14:26.
      const rawStep = this.getAttribute('data-quiz-step');
      if (!rawStep || !/^\d+$/.test(rawStep)) return;
      const step = parseInt(rawStep, 10);
      const value = this.getAttribute('data-quiz-value');

      const siblings = this.parentElement.querySelectorAll('.cart-quiz-option-btn');
      siblings.forEach(s => s.classList.remove('selected'));
      this.classList.add('selected');

      answers[`f${step}`] = value;

      const nextStep = step + 1;
      const progressText = quizModal.querySelector('#cart-quiz-progress-text');
      const progressRects = quizModal.querySelectorAll('.svg-progress-fill');
      
      if(nextStep <= 6) {
        if(progressText) progressText.innerText = `Frage ${nextStep} von 6`;
        const percentage = ((step / 6) * 100) + '%';
        progressRects.forEach(rect => rect.style.width = percentage);
      }
      
      setTimeout(() => {
        const currentStepEl = document.getElementById(`cart-quiz-step-${step}`);
        if(currentStepEl) currentStepEl.style.display = 'none';

        if(nextStep <= 6) {
          const nextStepEl = document.getElementById(`cart-quiz-step-${nextStep}`);
          if(nextStepEl) nextStepEl.style.display = 'block';
        } else {
          progressRects.forEach(rect => rect.style.width = '100%');
          evaluateResult();
        }
      }, 350);
    });
  });

  function resetQuiz() {
    answers = { f1: '', f2: '', f3: '', f4: '', f5: '', f6: '' };
    optionBtns.forEach(btn => btn.classList.remove('selected'));
    for(let i=1; i<=7; i++) {
       const el = document.getElementById(`cart-quiz-step-${i}`);
       if(el) el.style.display = i === 1 ? 'block' : 'none';
    }
    // BODY-RESET-V51-MARKER: BUG-FIX #2 — Body-Quiz state komplett resetten
    // RITUAL-STUFEN-V6: Ritual-Stufe ebenfalls resetten
    document.querySelectorAll('.body-quiz-step, #cart-quiz-body-bridge, #cart-quiz-body-result, #cart-quiz-ritual-step, #cart-quiz-oil-step').forEach(el => {
      el.style.display = 'none';
    });
    /* RITUAL-STUFEN-V6.6 BUG-FIX: Hard-Hide-Styles von hideHairResult() zurücksetzen,
       sonst bleibt Step 7 (und die Body-Bridge) im nächsten Durchlauf unsichtbar. */
    [document.getElementById('cart-quiz-step-7'), document.getElementById('cart-quiz-body-bridge')].forEach(el => {
      if (el) { el.style.visibility = ''; el.style.height = ''; el.style.overflow = ''; }
    });
    document.querySelectorAll('.body-quiz-step .cart-quiz-option-btn.selected').forEach(b => b.classList.remove('selected'));
    window.__bodyFirstMode = false;
    window.__bodyFirstModeRequested = false;
    window.__loonaBoxAdded = false;
    loadingScreen.style.display = 'none';
    resultContainer.innerHTML = '';
    const progressWrapper = quizModal.querySelector('#cart-quiz-progress-wrapper');
    if(progressWrapper) progressWrapper.style.display = 'block';
    const progressText = quizModal.querySelector('#cart-quiz-progress-text');
    const progressRects = quizModal.querySelectorAll('.svg-progress-fill');
    if(progressText) progressText.innerText = `Frage 1 von 6`;
    progressRects.forEach(rect => rect.style.width = '0%');
  }

  function evaluateResult() {
    loadingScreen.style.display = 'flex';
    const progressWrapper = quizModal.querySelector('#cart-quiz-progress-wrapper');
    if(progressWrapper) progressWrapper.style.display = 'none';

    let scores = { 'pure': 0, 'scalp': 0, 'curl': 0, 'strength': 0 };

    if (answers.f1 === 'haarausfall') scores.strength += 2;
    if (answers.f1 === 'locken_unsichtbar') scores.curl += 2;
    if (answers.f1 === 'fettet_nach') scores.pure += 2;
    if (answers.f1 === 'jucken_schuppen') scores.scalp += 2;
    if (answers.f1 === 'haarbruch') scores.strength += 2;
    if (answers.f1 === 'sehr_trocken') scores.scalp += 2;
    // V3.1: F1.G Neutral-Anker PURE DETOX +1 (leichter Anker, kein Override echter F4/F5/F6-Signale)
    if (answers.f1 === 'haar_okay_umsteigen') scores.pure += 1;

    if (answers.f3 === 'neu') scores.pure += 1;
    if (answers.f3 === 'probiert_aufgehoert') scores.pure += 1;

    if (answers.f4 === 'fettig') scores.pure += 1;
    if (answers.f4 === 'sensibel') scores.scalp += 1;
    if (answers.f4 === 'trocken') scores.scalp += 1;
    if (answers.f4 === 'mischhaar') scores.pure += 1;

    if (answers.f5 === 'fein') scores.strength += 1;
    if (answers.f5 === 'lockig') scores.curl += 1;
    if (answers.f5 === 'blondiert') scores.scalp += 1;
    if (answers.f5 === 'gefaerbt') scores.curl += 1;

    if (answers.f6 === 'seltener_waschen') scores.pure += 1;
    if (answers.f6 === 'beruhigen') scores.scalp += 1;
    if (answers.f6 === 'staerken') scores.strength += 1;
    if (answers.f6 === 'locken') scores.curl += 1;

    let winner = 'pure';
    let maxScore = -1;
    let tiedBoxes = [];

    for (const [box, score] of Object.entries(scores)) {
      if (score > maxScore) { maxScore = score; tiedBoxes = [box]; } 
      else if (score === maxScore) { tiedBoxes.push(box); }
    }

    if (tiedBoxes.length === 1) {
      winner = tiedBoxes[0];
    } else {
      let overrideBox = null;
      if (answers.f1 === 'haarausfall' && tiedBoxes.includes('strength')) overrideBox = 'strength';
      if (answers.f1 === 'locken_unsichtbar' && tiedBoxes.includes('curl')) overrideBox = 'curl';
      if (answers.f1 === 'fettet_nach' && tiedBoxes.includes('pure')) overrideBox = 'pure';
      if (answers.f1 === 'jucken_schuppen' && tiedBoxes.includes('scalp')) overrideBox = 'scalp';
      if (answers.f1 === 'haarbruch' && tiedBoxes.includes('strength')) overrideBox = 'strength';
      if (answers.f1 === 'sehr_trocken' && tiedBoxes.includes('scalp')) overrideBox = 'scalp';
      // V3.1 Tiebreaker 1b: F1.G Neutral → nächststärkstes Signal F4 → F5 → F6
      if (answers.f1 === 'haar_okay_umsteigen' && !overrideBox) {
        // F4-Signal
        if (answers.f4 === 'fettig' && tiedBoxes.includes('pure')) overrideBox = 'pure';
        else if (answers.f4 === 'mischhaar' && tiedBoxes.includes('pure')) overrideBox = 'pure';
        else if (answers.f4 === 'sensibel' && tiedBoxes.includes('scalp')) overrideBox = 'scalp';
        else if (answers.f4 === 'trocken' && tiedBoxes.includes('scalp')) overrideBox = 'scalp';
        // F5-Signal
        else if (answers.f5 === 'fein' && tiedBoxes.includes('strength')) overrideBox = 'strength';
        else if (answers.f5 === 'lockig' && tiedBoxes.includes('curl')) overrideBox = 'curl';
        // F6-Signal
        else if (answers.f6 === 'seltener_waschen' && tiedBoxes.includes('pure')) overrideBox = 'pure';
        else if (answers.f6 === 'beruhigen' && tiedBoxes.includes('scalp')) overrideBox = 'scalp';
        else if (answers.f6 === 'staerken' && tiedBoxes.includes('strength')) overrideBox = 'strength';
        else if (answers.f6 === 'locken' && tiedBoxes.includes('curl')) overrideBox = 'curl';
      }
      winner = overrideBox ? overrideBox : (tiedBoxes.includes('pure') ? 'pure' : tiedBoxes[0]);
    }

    let boxHeadline = 'Pure Detox Box für die Tiefenreinigung';
    let productHandle = 'pure-detox-box';
    let resultTitle = 'Dein Haar braucht keinen neuen Pflegestoff, sondern einen Reset. Wir entfernen Rückstände von altem Shampoo.';
    let resultBtnText = 'Meinen Haar-Reset starten';
    
    if (winner === 'scalp') {
      boxHeadline = 'Scalp Harmony Box für empfindliche Kopfhaut';
      productHandle = 'scalp-harmony-box';
      resultTitle = 'Wenn deine Kopfhaut durch Jucken oder Schuppen spricht, braucht sie Ruhe und keine Aggression.';
      resultBtnText = 'Meine Kopfhaut beruhigen';
    } else if (winner === 'curl') {
      boxHeadline = 'Curl Awakening Box für definierte Locken';
      productHandle = 'curl-awakening-box';
      resultTitle = 'Deine Locken sind nicht weg, sie sind nur verdeckt. Wir befreien dein natürliches Lockenmuster Schritt für Schritt.';
      resultBtnText = 'Meine Locken befreien';
    } else if (winner === 'strength') {
      boxHeadline = 'Strength & Grow Box für kraftloses Haar';
      productHandle = 'strength-grow-box';
      resultTitle = 'Was oft wie Haarausfall aussieht, ist häufig Haarbruch. Wir stärken die Haarfaser für vollere Längen.';
      resultBtnText = 'Mein Haar stärken';
    }

    setTimeout(async () => {
      loadingScreen.style.display = 'none';
      const step7 = document.getElementById('cart-quiz-step-7');
      if(step7) step7.style.display = 'block';
      if (typeof window.__lqApplyTierChip === 'function') window.__lqApplyTierChip(); /* QUIZ-FIX-V9 */
      if (step7) { step7.classList.add('lq-v2-wait'); setTimeout(() => step7.classList.remove('lq-v2-wait'), 4000); } /* QUIZ-FLOW-V2 */

      const step7Headline = document.getElementById('cart-quiz-result-headline');
      if (step7Headline) {
         step7Headline.innerHTML = `Dein perfektes Match:<br><span style="color:#d4af37; font-size:26px;">${boxHeadline}</span>`;
      }

      try {
        const resp = await fetch(`/products/${productHandle}.js`);
        let product = null;
        if (!resp.ok) {
           const fallbackResp = await fetch('/products.json?limit=1');
           const data = await fallbackResp.json();
           product = data.products[0];
        } else {
           product = await resp.json();
        }
        
        resultMessage.innerHTML = `<div class='result-hero-text'>Deine perfekte Routine gefunden.</div>
        <div class="result-scarcity-notice" style="background:#fdfaf2; border:1px solid #d4af37; color:#111; padding:12px; border-radius:8px; margin-bottom:25px; text-align:center; font-weight:600; font-size:15px;">
           Zum Launch: Bis zu 30 % Einführungsrabatt — nur für kurze Zeit.
        </div>
        <div class='result-patience-notice'><strong>Wichtig: Deine Geduld wird belohnt!</strong><br>Gib deinem Haar drei bis vier Wochen Zeit. Die meisten Kundinnen sehen erste Veränderungen nach zwei bis drei Wäschen – das volle Ergebnis entfaltet sich über den kompletten Zyklus der Box.</div>
        <!-- BLONDIERT-HINWEIS-V1 (Joshua 05.10.): nur bei F5 = blondiert; lqFlowLayout haengt ihn hinter den Geduld-Hinweis -->
        ${answers.f5 === 'blondiert' ? `<div class="result-blondiert-notice" style="background:#fdfaf2; border:1px solid #f2e3be; border-top:3px solid #d4af37; border-radius:8px; padding:18px; margin-bottom:35px; font-size:15px; line-height:1.5; text-align:left; color:#444;"><strong>Blondiert?</strong> Dann braucht dein Haar zwei Dinge. Am Ansatz die Umstellung: meist 2 bis 6 Wochen, in denen er schneller nachfetten kann. In den Längen mehr Pflege, weil sie oft trockener sind. Schäum die Seife am Ansatz auf, nimm nach jeder Wäsche die saure Rinse und gib trockenen Spitzen bei Bedarf ein paar Tropfen Root & Shine Hair Elixir. Fühlt sich dein Haar nach 6 Wochen noch strohig oder fettig an, schreib uns, dann suchen wir gemeinsam eine passendere Seife.</div>` : ''}
        <!-- BOX-STUFEN-REVEAL-V1-MARKER: image-based per-box reveal replaces text FYI -->
        ${(function(){
          const STUFEN_IMAGES = {
            'pure-detox-box': 'https://cdn.shopify.com/s/files/1/0152/0684/2468/files/loonas_waschanleitung_Pure_Detox_05-1.jpg?width=1400&format=webp',
            'curl-awakening-box': 'https://cdn.shopify.com/s/files/1/0152/0684/2468/files/loonas_waschanleitung_Curl_Awakening_05-1_page-0001.jpg?width=1400&format=webp',
            'strength-grow-box': 'https://cdn.shopify.com/s/files/1/0152/0684/2468/files/Bildschirmfoto_2026-03-12_um_01.25.24.png?width=1400&format=webp',
            'scalp-harmony-box': 'https://cdn.shopify.com/s/files/1/0152/0684/2468/files/Bildschirmfoto_2026-03-12_um_01.24.53.png?width=1400&format=webp'
          };
          const url = STUFEN_IMAGES[product.handle];
          if (!url) return '';
          return `<div class="result-stufen-block" style="margin:24px 0 0 0; padding:20px 18px; background:linear-gradient(180deg,#fffdf6 0%,#fdfaf2 100%); border:1px solid #e8d89e; border-radius:14px; text-align:center; box-shadow:0 1px 3px rgba(0,0,0,0.05);">
            <div style="display:inline-flex; align-items:center; gap:8px; margin-bottom:8px; padding:5px 13px; background:#fff; border:1px solid #f2e3be; border-radius:18px;">
              <div style="background:#d4af37; color:#fff; width:22px; height:22px; border-radius:50%; display:flex; align-items:center; justify-content:center; font-weight:700; font-size:12px;">i</div>
              <div style="font-size:12px; font-weight:600; color:#3a2e1a; letter-spacing:0.2px;">Was drin ist & wie du sie nutzt</div>
            </div>
            <p style="margin:6px 0 14px 0; font-size:13px; color:#6b5b3a; line-height:1.5;"><strong style="color:#3a2e1a;">4 Seifen.</strong> Aufsteigende Überfettung. Geführte Reihenfolge — kein Raten.</p>
            <img src="${url}" alt="Box-Inhalt mit Überfettungsstufen — geführte Anwendungsreihenfolge" width="600" height="300" loading="lazy" style="max-width:100%; height:auto; border-radius:10px; display:block; margin:0 auto; box-shadow:0 2px 6px rgba(58,46,26,0.08);">
            <p style="margin:14px 0 0 0; font-size:11px; color:#8a7752; line-height:1.5; font-style:italic;">Bei Bedarf zeigen wir dir nach dem Kauf eine ausführliche Waschanleitung — inklusive Wochen-Plan.</p>
          </div>`;
        })()}`;
        
        await renderProduct(product.handle, product.variants[0].id, resultTitle, resultBtnText);
      } catch (e) {
        resultContainer.innerHTML = '<p>Bitte wende dich an unseren Support.</p>';
      }
    }, 1200);
  }

  /* QUIZ-VALUE-V10 (Joshua 28.09.): Preisblock am Box-Ergebnis zeigt den KOMPLETTEN Vorteil der gewaehlten
     Stufe: Box statt 4 Einzelseifen + Gratis-Koerperseife + (Stufe 2/3) Elixier im Set. Werte kommen async
     nach (Token schuetzt vor alten Antworten bei erneutem Quiz-Durchlauf). */
  const lqVal = { tok: 0, boxPrice: 0, boxFull: 0, gift: 0, oilPrice: 0, oilPay: 0, oilOn: false };
  function lqFmt(c) {
    return new Intl.NumberFormat(window.Shopify.locale || 'de-DE', { style: 'currency', currency: (window.Shopify.currency && window.Shopify.currency.active) || 'EUR' }).format(c / 100);
  }
  function lqRenderPrice() {
    const soaps = Math.max(lqVal.boxFull, lqVal.boxPrice);
    const boxWas = soaps + lqVal.gift;
    const comboWas = boxWas + lqVal.oilPrice;
    const comboPay = lqVal.boxPrice + lqVal.oilPay;
    const comboWasEl = document.getElementById('lq-combo-was');
    const comboSaveEl = document.getElementById('lq-combo-save');
    const soloEl = document.getElementById('lq-solo-price');
    if (comboWasEl && comboWas > comboPay) comboWasEl.textContent = lqFmt(comboWas);
    if (comboSaveEl && comboWas > comboPay) comboSaveEl.textContent = 'Du sparst ' + lqFmt(comboWas - comboPay);
    if (soloEl && boxWas > lqVal.boxPrice) soloEl.innerHTML = lqFmt(lqVal.boxPrice) + ' <s style="color:#999; font-size:12px;">' + lqFmt(boxWas) + '</s>';
    const priceEl = resultContainer.querySelector('.cart-quiz-price');
    if (!priceEl) return;
    const full = lqVal.oilOn ? comboWas : boxWas;
    const pay = lqVal.oilOn ? comboPay : lqVal.boxPrice;
    if (full <= pay) { priceEl.textContent = lqFmt(pay); return; }
    const rows = [];
    if (soaps > lqVal.boxPrice) rows.push(['Box statt 4 Einzelseifen (' + lqFmt(soaps) + ')', soaps - lqVal.boxPrice]);
    if (lqVal.gift) rows.push(['Körperseife nach Wahl gratis', lqVal.gift]);
    if (lqVal.oilOn && lqVal.oilPrice > lqVal.oilPay) rows.push(['Root &amp; Shine Elixir im Set', lqVal.oilPrice - lqVal.oilPay]);
    priceEl.innerHTML = lqFmt(pay) + ' <s class="lq-was">' + lqFmt(full) + '</s>'
      + '<div class="lq-save">Du sparst ' + lqFmt(full - pay) + '</div>'
      + '<ul class="lq-save-rows">' + rows.map(r => '<li><span>' + r[0] + '</span><span>−' + lqFmt(r[1]) + '</span></li>').join('') + '</ul>'
      + '<div class="lq-save-note">Gesamtwert = alles einzeln gekauft, jede Seife der Box einzeln gerechnet. Gratis-Seife und Set-Vorteil zieht der Warenkorb automatisch ab.</div>';
    if (typeof window.__lqAfterPrice === 'function') { try { window.__lqAfterPrice(priceEl); } catch (e) {} } /* QUIZ-AOV-V23 */
  }

  async function renderProduct(handle, variantId, resultTitle, resultBtnText) {
    resultContainer.innerHTML = '<div class="loading-overlay__spinner">...</div>';

    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) throw new Error("Product not found");
      const product = await response.json();

      const variant = product.variants.find(v => v.id.toString() === variantId.toString()) || product.variants[0];
      const priceHtml = new Intl.NumberFormat(window.Shopify.locale || 'de-DE', { style: 'currency', currency: window.Shopify.currency.active || 'EUR' }).format(variant.price / 100);

      const html = `
        <!-- QUIZ-FIX-V9: doppelter "1 Deine Haarseifen-Box"-Chip entfernt (Stufen-Chip steht schon oben) -->
        <div class="result-product-card" data-lfc-handle="${handle}">
          <div class="cart-quiz-product-image">
             <img src="${product.featured_image}" alt="${product.title}" width="150" height="150" style="height:auto;" loading="lazy" />
          </div>
          <div class="cart-quiz-product-info">
            <h3 class="h5" style="margin-bottom: 12px; font-weight: bold; line-height: 1.4;">${resultTitle}</h3>
            <div class="cart-quiz-price">${priceHtml}</div>
            
            <!-- BODY-RESET-V5-MARKER: GOLDENER CTA + silent ATC + body-flow flag + extra-strong gold forcing -->
            <button class="cta-winner js-cart-quiz-add-btn loonas-gold-cta" data-variant-id="${variant.id}" data-body-quiz-flow="true">${resultBtnText}</button>
            
            <!-- HAIR-QUIZ-V3.1-MARKER: Empathy-Microcopy (Mehrfach-Persona Off-Ramp) -->
            <aside class="quiz-result-empathy" style="margin-top:18px; padding:14px 16px; background:#faf8f3; border:1px solid #e8dec4; border-radius:10px; text-align:left;">
              <p style="margin:0 0 6px 0; font-size:13px; font-weight:600; color:#2b2b2b;">Du fühlst dich noch unsicher?</p>
              <p style="margin:0 0 10px 0; font-size:12px; color:#555; line-height:1.5;">Hast du mehrere Probleme gleichzeitig oder bist dir nicht ganz sicher, ob diese Box zu dir passt? Schreib uns kurz – wir helfen dir persönlich weiter.</p>
              <a href="mailto:service.loonas@gmail.com?subject=Quiz-Beratung%20-%20Welche%20Box%20passt%20zu%20mir%3F" style="display:inline-block; font-size:12px; font-weight:600; color:#d4af37; text-decoration:underline;" data-quiz-empathy-cta="true" onclick="if(window.LoonasChat){event.preventDefault();window.LoonasChat.open();}else if(window.GorgiasChat){event.preventDefault();window.GorgiasChat.open();}">Persönlich beraten lassen →</a>
            </aside>
            
            <div class="trust-signals">
               <ul style="margin-top:20px; text-align:left; font-size:12px; list-style:none; padding:0;">
                 <li style="margin-bottom:8px; display:flex; align-items:center;"><svg style="width:16px;height:16px;margin-right:8px;fill:#b08d2a;flex-shrink:0;" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg> <span>100 Tage Geld-zurück-Garantie auf die Seifen deiner ersten Bestellung (Bedingungen: <a href="/policies/terms-of-service" style="color:#b08d2a; text-decoration:underline;">§ 6a AGB</a>)</span></li>
                 <li style="margin-bottom:8px; display:flex; align-items:center;"><svg style="width:16px;height:16px;margin-right:8px;fill:#d4af37;flex-shrink:0;" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg> Über 9.300 verifizierte Fünf-Sterne-Bewertungen</li>
                 <li style="display:flex; align-items:center;"><svg style="width:16px;height:16px;margin-right:8px;fill:#2b2b2b;flex-shrink:0;" viewBox="0 0 24 24"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/></svg> Handgemacht in Deutschland in kleinen Chargen</li>
               </ul>
            </div>
          </div>
        </div>
      `;

      resultContainer.innerHTML = html;

      /* QUIZ-VALUE-V10: Wert der Box (Einzelseifen) + Gratis-Seife laden, dann Preisblock neu zeichnen */
      const lqTok = ++lqVal.tok;
      Object.assign(lqVal, { boxPrice: variant.price, boxFull: 0, gift: 0, oilPrice: 0, oilPay: 0, oilOn: false });
      Promise.all([
        typeof window.__lqBoxFull === 'function' ? window.__lqBoxFull(handle) : 0,
        typeof window.__lqGiftValue === 'function' ? window.__lqGiftValue() : 0
      ]).then(([bf, gift]) => {
        if (lqTok !== lqVal.tok) return;
        lqVal.boxFull = bf || 0;
        lqVal.gift = gift || 0;
        lqRenderPrice();
      }).catch(() => {});

      // RITUAL-STUFEN-V6: Stufe 2 — Root & Shine als Add-on unter der Box-Karte
      renderOilUpsell(variant, resultBtnText).catch(() => {}).then(() => {
        try { lqFlowLayout(); } catch (e) { console.error(e); }
        finally { const s7 = document.getElementById('cart-quiz-step-7'); if (s7) s7.classList.remove('lq-v2-wait'); }
      }); /* QUIZ-FLOW-V2 */

    } catch (e) {
      console.error(e);
      resultContainer.innerHTML = '<p>Produkt konnte nicht geladen werden.</p>';
    }
  }

  /* QUIZ-FLOW-V2 (Joshua 28.09.): Ergebnis als EIN Fluss statt 5-6 Einzelbloecke.
     Bestehende Knoten werden nur umgehaengt (IDs, Listener, Oel-Mechanik bleiben unveraendert).
     Ein goldener Faden fuehrt Schritt fuer Schritt: 1 Deine Box -> 2 Was drin ist & wie du sie nutzt
     (Geduld-Hinweis + Stufen-Bild in EINEM Block) -> 3 Dein Ritual (Oel-Wahl) -> 4 Preis + CTA.
     Launch-Rabatt-Zeile bleibt oben (Joshua 28.09.: nur Neukunden sehen sie). */
  function lqFlowLayout() {
    const msg = resultMessage;
    const card = resultContainer.querySelector('.result-product-card');
    if (!card || resultContainer.querySelector('.lq-flow')) return;
    const img = card.querySelector('.cart-quiz-product-image img');
    const title = card.querySelector('.cart-quiz-product-info h3');
    const price = card.querySelector('.cart-quiz-price');
    const cta = card.querySelector('.js-cart-quiz-add-btn');
    const trust = card.querySelector('.trust-signals');
    const help = card.querySelector('.quiz-result-empathy a');
    const hero = msg ? msg.querySelector('.result-hero-text') : null;
    const patience = msg ? msg.querySelector('.result-patience-notice') : null;
    const stufen = msg ? msg.querySelector('.result-stufen-block') : null;
    const upsell = document.getElementById('cart-quiz-oil-upsell');
    if (!cta) return;

    const flow = document.createElement('div');
    flow.className = 'lq-flow';
    let n = 0;
    function node(kicker, cls) {
      n += 1;
      const el = document.createElement('section');
      el.className = 'lq-node' + (cls ? ' ' + cls : '');
      el.innerHTML = '<div class="lq-dot" aria-hidden="true">' + n + '</div><div class="lq-kicker">' + kicker + '</div><div class="lq-body"></div>';
      flow.appendChild(el);
      return el.querySelector('.lq-body');
    }

    // 1 - Deine Box
    const b1 = node('Deine Box');
    const box = document.createElement('div');
    box.className = 'lq-box';
    if (img) { img.removeAttribute('style'); img.className = 'lq-box-img'; box.appendChild(img); }
    if (title) { title.removeAttribute('style'); title.className = 'lq-box-title'; box.appendChild(title); }
    b1.appendChild(box);

    // 2 - Was drin ist & wie du sie nutzt (Geduld + Stufen verschmolzen)
    if (stufen || patience) {
      const b2 = node('Was drin ist &amp; wie du sie nutzt');
      if (stufen) {
        const chip = stufen.firstElementChild;
        if (chip && /Was drin ist/.test(chip.textContent || '')) chip.remove();
        stufen.removeAttribute('style');
        stufen.className = 'lq-merge';
        b2.appendChild(stufen);
      }
      if (patience) {
        patience.className = 'lq-note';
        const tail = stufen ? stufen.lastElementChild : null;
        if (stufen && tail && tail.tagName === 'P') stufen.insertBefore(patience, tail);
        else b2.appendChild(patience);
      }
      /* BLONDIERT-HINWEIS-V1: direkt hinter dem Geduld-Hinweis, gleiche Optik (lq-note) */
      const blond = msg ? msg.querySelector('.result-blondiert-notice') : null;
      if (blond) {
        blond.removeAttribute('style');
        blond.className = 'lq-note lq-note--blondiert';
        if (patience && patience.parentNode) patience.parentNode.insertBefore(blond, patience.nextSibling);
        else b2.appendChild(blond);
      }
    }

    // 3 - Dein Ritual (Oel-Wahl) - nur wenn der Upsell existiert
    if (upsell) {
      const b3 = node('Dein Ritual — deine Wahl', 'lq-node--plain');
      const lbl = upsell.firstElementChild;
      if (lbl && /deine Wahl/.test(lbl.textContent || '')) lbl.remove();
      upsell.style.marginTop = '14px';
      b3.appendChild(upsell);
    }

    // 4 - Preis + CTA + Vertrauen
    const b4 = node('Dein Preis', 'lq-node--plain lq-node--cta');
    if (price) b4.appendChild(price);
    b4.appendChild(cta);
    if (trust) { trust.classList.add('lq-trust'); b4.appendChild(trust); }
    if (help) {
      const p = document.createElement('p');
      p.className = 'lq-help';
      p.appendChild(document.createTextNode('Mehrere Baustellen oder unsicher? '));
      p.appendChild(help);
      b4.appendChild(p);
    }

    if (hero) hero.remove();
    resultContainer.innerHTML = '';
    resultContainer.appendChild(flow);
  }

  /* ==================================================================
     RITUAL-STUFEN-V6: Öl-Upsell (mittleres Bündel)
     Selbst-deaktivierend: solange Root & Shine DRAFT/404/ausverkauft
     ist, erscheint hier NICHTS — das Quiz verhält sich exakt wie V5.4.
     Ab Launch (Produkt ACTIVE mit Bestand) erscheint der Toggle
     automatisch, ohne dass jemand etwas umstellen muss.
     ================================================================== */
  async function renderOilUpsell(boxVariant, boxBtnText) {
    const cfg = window.__loonaRitualConfig || {};
    if (!cfg.oilEnabled || !cfg.oilHandle) return;

    let oil = null;
    try {
      const r = await fetch(`/products/${cfg.oilHandle}.js`);
      if (!r.ok) return; // DRAFT oder gelöscht → Upsell unsichtbar
      oil = await r.json();
    } catch (e) { return; }
    const oilVariant = (oil.variants || []).find(v => v.available);
    if (!oilVariant) return; // ausverkauft → Upsell unsichtbar

    const fmt = new Intl.NumberFormat(window.Shopify.locale || 'de-DE', { style: 'currency', currency: (window.Shopify.currency && window.Shopify.currency.active) || 'EUR' });
    const oilPrice = oilVariant.price;                       // in Cent
    const discount = Math.min(cfg.oilDiscountCents || 0, oilPrice);
    const oilBundlePrice = oilPrice - discount;
    const boxPrice = boxVariant.price;
    const bundleTotal = boxPrice + oilBundlePrice;
    const bundleFull = boxPrice + oilPrice;
    lqVal.oilPrice = oilPrice; lqVal.oilPay = oilBundlePrice; /* QUIZ-VALUE-V10 */

    const cta = resultContainer.querySelector('.js-cart-quiz-add-btn');
    const priceEl = resultContainer.querySelector('.cart-quiz-price');
    const card = resultContainer.querySelector('.result-product-card');
    if (!cta || !card) return;
    const originalPriceHtml = priceEl ? priceEl.innerHTML : '';

    const upsell = document.createElement('div');
    upsell.id = 'cart-quiz-oil-upsell';
    upsell.style.cssText = 'margin-top:16px; text-align:left; position:relative;';
    /* OFFER-V6 (Ulrike 30.08.): passiver "+ Dazu"-Toggle -> geankerte Zwei-Karten-Wahl.
       DD 30.08.: St2-Uptake lag bei 21 % — die Empfehlung wird jetzt sichtbar geankert,
       aber NICHTS vorausgewaehlt (gleiche §312a-Linie wie der PDP-Pitch: Default "Nur die Box").
       Mechanik-Kontrakt unveraendert: data-oil-variant-id, __loonaOilChoice, Preis-Swap, tierIntent. */
    upsell.innerHTML = `
      <div style="font-size:11px; font-weight:700; letter-spacing:.08em; text-transform:uppercase; color:#8a7752; margin:0 0 10px 2px;">Dein Ritual — deine Wahl</div>
      <button type="button" id="cart-quiz-oil-combo" aria-pressed="false" style="display:block; width:100%; text-align:left; background:#fffdf6; border:2px solid #d4af37; border-radius:14px; padding:18px 16px 14px; cursor:pointer; position:relative; box-shadow:0 6px 18px rgba(58,46,26,.08); font:inherit;">
        <span style="position:absolute; top:-11px; left:14px; background:#d4af37; color:#fff; padding:2px 12px; border-radius:10px; font-size:11px; font-weight:700; letter-spacing:.4px;">Unsere Empfehlung — Stufe 2</span>
        <span style="display:flex; align-items:center; gap:12px;">
          <img src="${oil.featured_image || ''}" alt="${oil.title}" loading="lazy" style="width:56px; height:56px; object-fit:cover; border-radius:8px; background:#f5f5f5; flex-shrink:0;" />
          <span style="flex:1; min-width:0;">
            <span style="display:block; font-weight:700; font-size:14px; color:#111; line-height:1.3;">Deine Box + Root &amp; Shine Hair Elixir</span>
            <span style="display:block; font-size:12px; color:#666; margin-top:2px; line-height:1.4;">Schritt 3 nach der Wäsche: pflegt Ansatz, Längen &amp; Spitzen — silikonfrei, kein Build-up.</span>
            <span style="display:block; font-size:14px; margin-top:6px;"><strong style="color:#b08d2a; font-size:16px;">${fmt.format(bundleTotal / 100)}</strong> <s id="lq-combo-was" style="color:#999; font-size:12px;">${fmt.format(bundleFull / 100)}</s> <span id="lq-combo-save" style="display:inline-block; white-space:nowrap; background:#d4af37; color:#1f1a0e; border-radius:8px; padding:1px 7px; font-size:11px; font-weight:700;">Du sparst ${fmt.format(discount / 100)}</span></span>
          </span>
          <span id="cart-quiz-oil-combo-mark" style="flex-shrink:0; width:22px; height:22px; border:2px solid #d4af37; border-radius:50%; display:inline-flex; align-items:center; justify-content:center; color:#fff; background:#fff; font-size:13px; font-weight:700;"></span>
        </span>
      </button>
      <button type="button" id="cart-quiz-oil-solo" aria-pressed="true" style="display:block; width:100%; text-align:left; background:#fff; border:1.5px solid #e2dcc9; border-radius:12px; padding:12px 16px; cursor:pointer; margin-top:8px; font:inherit;">
        <span style="display:flex; align-items:center; justify-content:space-between; gap:10px;">
          <span style="font-weight:600; font-size:13px; color:#444;">Nur die Box</span>
          <span style="display:inline-flex; align-items:center; gap:8px;"><span id="lq-solo-price" style="font-size:13px; color:#666;">${fmt.format(boxPrice / 100)}</span><span id="cart-quiz-oil-solo-mark" style="width:20px; height:20px; border:2px solid #cfc9b8; border-radius:50%; display:inline-flex; align-items:center; justify-content:center; color:#fff; background:#b8b2a2; font-size:12px; font-weight:700;">✓</span></span>
        </span>
      </button>`;
    card.insertAdjacentElement('afterend', upsell);

    const comboBtn = upsell.querySelector('#cart-quiz-oil-combo');
    const soloBtn = upsell.querySelector('#cart-quiz-oil-solo');
    const comboMark = upsell.querySelector('#cart-quiz-oil-combo-mark');
    const soloMark = upsell.querySelector('#cart-quiz-oil-solo-mark');
    /* COMBO-BILD-OEL (Ulrike 18.10.): Box-Bild im Ergebnis wird nur bei gewähltem Öl zum Combo-Bild (Box + Haaröl).
       Reine Anzeige im Quiz; Warenkorb, Varianten und Produktbilder bleiben unverändert. */
    const lfcImg = card.querySelector('.cart-quiz-product-image img');
    const lfcUrl = (window.__lfComboBilder || {})[card.getAttribute('data-lfc-handle') || ''];
    const lfcOrig = lfcImg ? { src: lfcImg.getAttribute('src'), alt: lfcImg.getAttribute('alt') } : null;
    function lfcQuizBild(on) {
      try {
        if (!lfcImg || !lfcUrl || !lfcOrig) return;
        if (on) {
          lfcImg.setAttribute('src', lfcUrl + '&width=432');
          lfcImg.setAttribute('alt', (lfcOrig.alt || '') + ' mit Root & Shine Hair Elixir');
          lfcImg.setAttribute('data-lfc-combo', '1');
        } else {
          lfcImg.setAttribute('src', lfcOrig.src);
          lfcImg.setAttribute('alt', lfcOrig.alt || '');
          lfcImg.removeAttribute('data-lfc-combo');
        }
      } catch (e) {}
    }
    function setOil(on, viaUser) {
      lfcQuizBild(on); /* COMBO-BILD-OEL */
      comboBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      soloBtn.setAttribute('aria-pressed', on ? 'false' : 'true');
      comboMark.textContent = on ? '✓' : '';
      comboMark.style.background = on ? '#d4af37' : '#fff';
      comboBtn.style.background = on ? '#fdf5e0' : '#fffdf6';
      soloMark.textContent = on ? '' : '✓';
      soloMark.style.background = on ? '#fff' : '#b8b2a2';
      if (on) {
        cta.setAttribute('data-oil-variant-id', oilVariant.id);
        cta.innerHTML = 'Box + Öl in den Warenkorb';
        lqVal.oilOn = true; lqRenderPrice(); /* QUIZ-VALUE-V10: kompletter Wert statt nur Oel-Rabatt */
      } else {
        cta.removeAttribute('data-oil-variant-id');
        cta.innerHTML = boxBtnText;
        lqVal.oilOn = false; lqRenderPrice(); /* QUIZ-VALUE-V10 */
        if (viaUser) window.__loonaOilChoice = 'declined'; /* V7.2: aktiv abgewaehlt — Pitch spaeter erlaubt */
      }
    }
    comboBtn.addEventListener('click', function () { setOil(true, true); });
    soloBtn.addEventListener('click', function () { setOil(false, true); });
    setOil(false, false); /* Default: Nur die Box — kein vorausgewaehlter Zusatzkauf */

    /* QUIZ-AOV-V23 Variante A "Stufen-Leiter" (Ulrike 29.09.). Hypothese: Mit zwei Optionen (Box / Box + Elixier)
       fehlt der obere Anker; als dritte Karte ueber der Empfehlung macht das komplette Ritual (Stufe 3) die
       Stufe 2 zur Mitte (Kompromiss-Effekt). Nichts ist vorausgewaehlt. Stufe 3 legt jetzt Box + Elixier,
       die Reisebox waehlt die Kundin im letzten Schritt (bestehender Ritual-Schritt, Stufen-Intent 3). */
    (async function lqLadder() {
      try {
        if (!cfg.ritualEnabled) return;
        const hs = (cfg.dishHandles || []).filter(Boolean);
        const ps = await Promise.all(hs.map(h => fetch('/products/' + h + '.js').then(r => (r.ok ? r.json() : null)).catch(() => null)));
        let dish = null;
        for (let i = 0; i < ps.length; i++) {
          const v = ps[i] && (ps[i].variants || []).find(x => x.available);
          if (v) { dish = { p: ps[i], v: v, h: hs[i] }; break; }
        }
        if (!dish || !document.body.contains(upsell)) return;
        const live = (Date.now() / 1000) >= (cfg.discountsLiveAtS || 0);
        const dishPay = dish.v.price - (live ? Math.min(cfg.dishDiscountCents || 0, dish.v.price) : 0);
        let sisal = 0;
        if (cfg.sisalFree && cfg.sisalHandle) {
          const sp = await fetch('/products/' + cfg.sisalHandle + '.js').then(r => (r.ok ? r.json() : null)).catch(() => null);
          const sv = sp && (sp.variants || []).find(x => x.available);
          if (sv) sisal = sv.price;
        }
        const t3Pay = boxPrice + oilBundlePrice + dishPay;
        const dishName = /reisebox/i.test(dish.h) ? 'Reisebox aus Kork' : 'Seifenschale';
        const t3 = document.createElement('button');
        t3.type = 'button';
        t3.id = 'lq-tier3';
        t3.className = 'lq-t3';
        t3.setAttribute('aria-pressed', 'false');
        t3.innerHTML = '<span class="lq-t3-badge">Komplettes Ritual — Stufe 3</span>'
          + '<span class="lq-t3-row"><img src="' + (dish.p.featured_image || '') + '" alt="" loading="lazy" width="48" height="48">'
          + '<span class="lq-t3-txt"><strong>Box + Elixier + ' + dishName + '</strong>'
          + '<span>' + (sisal ? 'Sisal-Säckchen gratis dazu. ' : '') + 'Die ' + dishName + ' legst du im letzten Schritt dazu.</span>'
          + '<span class="lq-t3-price"><strong>' + fmt.format(t3Pay / 100) + '</strong> <s id="lq-t3-was"></s> <span id="lq-t3-save" class="lq-t3-save"></span></span></span>'
          + '<span class="lq-t3-mark" id="lq-t3-mark"></span></span>';
        upsell.insertBefore(t3, comboBtn);
        const t3mark = t3.querySelector('#lq-t3-mark');
        let sel = comboBtn.getAttribute('aria-pressed') === 'true' ? '2' : '1';
        const paint = function () {
          t3.setAttribute('aria-pressed', sel === '3' ? 'true' : 'false');
          t3.classList.toggle('is-on', sel === '3');
          t3mark.textContent = sel === '3' ? '✓' : '';
          if (sel === '3') {
            comboBtn.setAttribute('aria-pressed', 'false');
            comboMark.textContent = '';
            comboMark.style.background = '#fff';
            comboBtn.style.background = '#fffdf6';
          }
        };
        const pick = function (t, viaUser) {
          sel = t;
          setOil(t !== '1', viaUser);
          window.__loonaTier = t;
          if (typeof window.__lqApplyTierChip === 'function') window.__lqApplyTierChip();
          paint();
          lqRenderPrice();
        };
        window.__lqAfterPrice = function (priceEl) {
          const soaps = Math.max(lqVal.boxFull, lqVal.boxPrice);
          const full = soaps + lqVal.gift + oilPrice + dish.v.price + sisal;
          const wasEl = document.getElementById('lq-t3-was');
          const saveEl = document.getElementById('lq-t3-save');
          if (wasEl && full > t3Pay) wasEl.textContent = fmt.format(full / 100);
          if (saveEl && full > t3Pay) saveEl.textContent = 'Du sparst ' + fmt.format((full - t3Pay) / 100);
          if (sel === '3' && priceEl && !priceEl.querySelector('.lq-t3-note')) {
            /* QUIZ-FIX-V231 (Joshua 02.10.2026): Stufe 3 gewaehlt -> Preis, Streichpreis und Auflistung von Stufe 3
               (vorher blieben die Werte von Stufe 2 stehen). Der Warenkorb-Ablauf bleibt: jetzt Box + Elixier,
               die Reisebox im letzten Schritt. */
            const pay3 = lqVal.boxPrice + lqVal.oilPay + dishPay;
            const full3 = soaps + lqVal.gift + lqVal.oilPrice + dish.v.price + sisal;
            if (lqVal.oilPay && full3 > pay3) {
              const r3 = [];
              if (soaps > lqVal.boxPrice) r3.push(['Box statt 4 Einzelseifen (' + lqFmt(soaps) + ')', soaps - lqVal.boxPrice]);
              if (lqVal.gift) r3.push(['Körperseife nach Wahl gratis', lqVal.gift]);
              if (lqVal.oilPrice > lqVal.oilPay) r3.push(['Root &amp; Shine Elixir im Set', lqVal.oilPrice - lqVal.oilPay]);
              if (dish.v.price > dishPay) r3.push([dishName + ' im Set', dish.v.price - dishPay]);
              if (sisal) r3.push(['Sisal-Säckchen gratis', sisal]);
              priceEl.innerHTML = lqFmt(pay3) + ' <s class="lq-was">' + lqFmt(full3) + '</s>'
                + '<div class="lq-save">Du sparst ' + lqFmt(full3 - pay3) + '</div>'
                + '<ul class="lq-save-rows">' + r3.map(r => '<li><span>' + r[0] + '</span><span>−' + lqFmt(r[1]) + '</span></li>').join('') + '</ul>'
                + '<div class="lq-save-note">Gesamtwert = alles einzeln gekauft, jede Seife der Box einzeln gerechnet. Gratis-Seife und Set-Vorteil zieht der Warenkorb automatisch ab.</div>';
            }
            const n = document.createElement('div');
            n.className = 'lq-t3-note';
            n.textContent = 'Jetzt: Box + Elixier. Im letzten Schritt legst du die ' + dishName + ' für ' + fmt.format(dishPay / 100) + ' dazu' + (sisal ? ', das Sisal-Säckchen gibt es gratis.' : '.');
            priceEl.appendChild(n);
          }
        };
        t3.addEventListener('click', function () { pick('3', true); });
        comboBtn.addEventListener('click', function () { pick('2', true); });
        soloBtn.addEventListener('click', function () { pick('1', true); });
        if (window.__loonaTier === '3' && sel === '2') pick('3', false); else { paint(); lqRenderPrice(); }
      } catch (e) {}
    })();

    // RITUAL-STUFEN-V6.1 (05.08.): Stufen-Intent der Startseiten-Section.
    // Wer auf der Startseite Stufe 2/3 gewaehlt hat, bekommt das Oel im
    // Box-Ergebnis vorab aktiviert (abwaehlbar). Intent wird verbraucht.
    try {
      const tierIntent = sessionStorage.getItem('loonaTierIntent');
      if (tierIntent) sessionStorage.removeItem('loonaTierIntent');
      if (tierIntent) window.__loonaTier = tierIntent; /* QUIZ-FIX-V9 */
      if (tierIntent === '2' || tierIntent === '3') setOil(true, false);
    } catch (e) {}
  }
}



  // ===== BODY-RESET-V3-MARKER: Body-Quiz Engine V1.3 =====
  const BODY_SOAPS = {
    KR: { handle: 'kopie-von-kokosmilch-ringelblume-babyseife', variantId: '37468788588710', title: 'Kokosmilch & Ringelblume', subtitle: 'Mildeste Pflege · duftneutral' },
    BO: { handle: 'sussorange-mit-zedernholz-muskatsalbei', variantId: '37446515097766', title: 'Blutorange & Zedernholz', subtitle: 'Antioxidativ · regenerierend' },
    TL: { handle: 'franzosische-tonerde-mit-lavendel-teebaumol-gesichtsseife', variantId: '37447367884966', title: 'Grüne Tonerde + Lavendel & Teebaumöl', subtitle: 'Klärend · Gesicht & Körper' },
    AK: { handle: 'aktivkohle-mit-rosmarin-zitrone', variantId: '37447359529126', title: 'Aktivkohle + Rosmarin & Zitrone', subtitle: 'Tiefenreinigung · Talgbindung' },
    PT: { handle: 'kiefernadeltee-mit-zedernholz-wacholderbeere', variantId: '37446875676838', title: 'Kiefernadeltee + Zedernholz & Wacholderbeere', subtitle: 'Erdung · Tiefenreinigung' },
    RM: { handle: 'rote-mandarine-mit-patchouli-limette-korperseife', variantId: '52731809005832', title: 'Rote Mandarine + Patchouli & Limette', subtitle: 'Erfrischend · sanftes Peeling' },
    SP: { handle: 'sandelholz-pachouli', variantId: '37446582567078', title: 'Sandelholz & Patchouli', subtitle: 'Samtig-cremig · sanftes Peeling' },
    AV: { handle: 'aloe-vera-mit-gruner-minze-eucalyptus', variantId: '37446769377446', title: 'Aloe Vera + Zitronengras & Pfefferminze', subtitle: 'Kühlend · erfrischend' },
    CT: { handle: 'chai-tee-mit-sussorange-nelke', variantId: '37446782550182', title: 'Chai Tee + Blutorange & Nelkenblätteröl', subtitle: 'Wärmend · energetisierend' }
  };

  /* QUIZ-FIX-V9 (Joshua-Befund 28.09.): Gratis-Seifen-Varianten zur Laufzeit aufloesen.
     Vorher: fest verdrahtete IDs (KR 120 g ausverkauft, RM-ID existiert nicht mehr) -> /cart/add.js 422
     -> "Fehler - nochmal versuchen" -> Sackgasse vor Schale/Reisebox.
     Jetzt: bevorzugte ID, sonst verfuegbares grosses Stueck ohne Schoenheitsmakel, sonst jede verfuegbare
     Variante ohne Makel, sonst irgendeine verfuegbare; nichts verfuegbar -> Seife faellt raus. */
  const __lqSoapCache = {};
  function lqFetchSoap(handle) {
    if (!__lqSoapCache[handle]) {
      __lqSoapCache[handle] = fetch('/products/' + handle + '.js').then(r => (r.ok ? r.json() : null)).catch(() => null);
    }
    return __lqSoapCache[handle];
  }
  async function lqResolveSoapId(vid) {
    const code = Object.keys(BODY_SOAPS).find(c => String(BODY_SOAPS[c].variantId) === String(vid));
    if (!code) return String(vid);
    const p = await lqFetchSoap(BODY_SOAPS[code].handle);
    if (!p || !p.variants) return String(vid);
    const vs = p.variants.filter(v => v.available);
    const pick = vs.find(v => String(v.id) === String(vid))
      || vs.find(v => /gro/i.test(v.title || '') && !/makel/i.test(v.title || ''))
      || vs.find(v => !/makel/i.test(v.title || ''));
    /* QUIZ-SOLDOUT-V11: Makel-Stücke nie als Gratis-Seife — ohne Variante ohne Makel gilt die Seife als ausverkauft */
    return pick ? String(pick.id) : null;
  }
  window.__lqResolveSoapIds = async function (ids) {
    const out = await Promise.all((ids || []).filter(Boolean).map(id => lqResolveSoapId(id).catch(() => String(id))));
    return out.filter(Boolean).filter((v, i, a) => a.indexOf(v) === i);
  };

  /* QUIZ-VALUE-V10 (Joshua 28.09.): Wert-Bausteine fuer alle Stufen, live aus /products/*.js.
     __lqBoxFull: Summe der 4 Box-Seifen einzeln (grosses Stueck ohne Makel, boxComponents aus der Section).
     __lqGiftValue: Wert der Gratis-Koerperseife = guenstigste verfuegbare Seife (konservativ, nie zu hoch).
     __lqCartValue: Gesamtwert/Zahlbetrag des Warenkorbs (Box-Zeilen mit Einzelseifen-Wert). */
  const __lqBoxFullCache = {};
  window.__lqBoxFull = function (boxHandle) {
    if (!__lqBoxFullCache[boxHandle]) {
      __lqBoxFullCache[boxHandle] = (async function () {
        const comps = ((window.__loonaRitualConfig || {}).boxComponents || {})[boxHandle];
        if (!comps || !comps.length) return 0;
        const prods = await Promise.all(comps.map(c => ritualFetchProduct(c.handle)));
        let sum = 0;
        for (let i = 0; i < comps.length; i++) {
          const c = comps[i];
          const vs = (prods[i] && prods[i].variants) || [];
          const match = v => (!c.pct || (v.title || '').indexOf(c.pct) !== -1);
          let v = vs.find(vv => match(vv) && /Gro/.test(vv.title || '') && !/akel/.test(vv.title || ''));
          if (!v) v = vs.find(match);
          if (!v || !v.price) return 0;
          sum += v.price;
        }
        return sum;
      })().catch(() => 0);
    }
    return __lqBoxFullCache[boxHandle];
  };
  window.__lqGiftValue = function () {
    if (!window.__lqGiftValueP) {
      window.__lqGiftValueP = Promise.all(Object.keys(BODY_SOAPS).map(c => lqFetchSoap(BODY_SOAPS[c].handle))).then(ps => {
        let min = 0;
        ps.forEach(p => {
          const vs = ((p && p.variants) || []).filter(v => v.available && !/makel/i.test(v.title || ''));
          const v = vs.find(x => /gro/i.test(x.title || '')) || vs[0];
          if (v && v.price && (!min || v.price < min)) min = v.price;
        });
        return min;
      }).catch(() => 0);
    }
    return window.__lqGiftValueP;
  };
  window.__lqCartValue = async function (cart) {
    const comps = (window.__loonaRitualConfig || {}).boxComponents || {};
    let full = 0, pay = 0;
    for (const it of ((cart && cart.items) || [])) {
      let unit = it.original_price || it.price || 0;
      if (comps[it.handle]) { const bf = await window.__lqBoxFull(it.handle); if (bf > unit) unit = bf; }
      full += unit * it.quantity;
      pay += (it.final_line_price !== undefined && it.final_line_price !== null) ? it.final_line_price : (it.price || 0) * it.quantity;
    }
    return { full: full, pay: pay };
  };

  /* QUIZ-SOLDOUT-V11 (Joshua 28.09.): Ist die empfohlene Gratis-Seife komplett ausverkauft (keine Variante ohne
     Schönheitsmakel), bleibt sie als Empfehlung sichtbar, aber als "Ausverkauft" markiert; darunter wählt die Kundin
     eine andere Seife, die GRATIS dazukommt. B1 (sensible Haut) hat keine eigenen Zusatzseifen -> feste Auswahl
     ohne Peeling-Seifen (Joshua: Sandelholz & Patchouli nicht für sensible Haut). */
  const LQ_SOLDOUT_ALTS = { B1: ['BO', 'AV', 'TL'] };
  async function lqSoldOutCheck(outcomeResult, soapCodes, addonCodes) {
    try {
      const code0 = soapCodes && soapCodes[0];
      if (!code0 || !BODY_SOAPS[code0]) return;
      if (await lqResolveSoapId(BODY_SOAPS[code0].variantId)) return; // verfügbar -> nichts tun
      const pool = (addonCodes && addonCodes.length) ? addonCodes : (LQ_SOLDOUT_ALTS[outcomeResult.outcomeId] || []);
      const avail = [];
      for (const c of pool) {
        if (c === code0 || !BODY_SOAPS[c]) continue;
        const id = await lqResolveSoapId(BODY_SOAPS[c].variantId);
        if (id) avail.push({ code: c, id: id });
      }
      const box = document.getElementById('cart-quiz-body-result');
      if (!box) return;
      const card = box.querySelector('.body-soap-card');
      if (card) {
        card.classList.add('lq-soldout');
        const badge = card.querySelector('div[style*="position:absolute"]');
        if (badge) { badge.textContent = 'Ausverkauft'; badge.classList.add('lq-soldout-badge'); }
      }
      const note = box.querySelector('.result-scarcity-notice');
      if (note) {
        note.innerHTML = avail.length
          ? 'Deine Empfehlung ist gerade ausverkauft. Wähle unten eine andere Körperseife — sie gehört <strong>GRATIS</strong> zu deiner Box.'
          : 'Deine Empfehlung ist gerade ausverkauft. Du kannst ohne Körperseife weitermachen.';
      }
      const oldAddons = document.getElementById('cart-quiz-body-addons');
      if (oldAddons) oldAddons.remove();
      const setIds = function (id) {
        document.querySelectorAll('#cart-quiz-body-take-now, #cart-quiz-body-to-hair, #cart-quiz-body-multi-add')
          .forEach(b => b.setAttribute('data-body-soaps', id || ''));
      };
      if (!avail.length) { setIds(''); return; }
      const wrap = document.createElement('div');
      wrap.id = 'lq-soldout-pick';
      wrap.innerHTML = '<div class="lq-soldout-head">Wähle deine Gratis-Seife</div>' + avail.map(function (a, i) {
        const s = BODY_SOAPS[a.code];
        return '<button type="button" class="lq-alt' + (i === 0 ? ' is-on' : '') + '" data-id="' + a.id + '" aria-pressed="' + (i === 0 ? 'true' : 'false') + '">'
          + '<img id="lq-alt-img-' + a.code + '" src="" alt="" width="48" height="48">'
          + '<span class="lq-alt-txt"><strong>' + s.title + '</strong><span>' + s.subtitle + '</span></span>'
          + '<span class="lq-alt-mark" aria-hidden="true"></span></button>';
      }).join('');
      const soapsEl = document.getElementById('cart-quiz-body-soaps');
      if (soapsEl && soapsEl.parentNode) soapsEl.parentNode.insertBefore(wrap, soapsEl.nextSibling);
      avail.forEach(function (a) {
        lqFetchSoap(BODY_SOAPS[a.code].handle).then(function (p) {
          const im = document.getElementById('lq-alt-img-' + a.code);
          if (im && p && p.featured_image) { im.src = p.featured_image; im.alt = p.title || ''; }
        });
      });
      setIds(avail[0].id);
      wrap.querySelectorAll('.lq-alt').forEach(function (btn) {
        btn.addEventListener('click', function () {
          wrap.querySelectorAll('.lq-alt').forEach(function (b) { b.classList.remove('is-on'); b.setAttribute('aria-pressed', 'false'); });
          btn.classList.add('is-on');
          btn.setAttribute('aria-pressed', 'true');
          setIds(btn.getAttribute('data-id'));
        });
      });
    } catch (e) {}
  }

  const BODY_OUTCOMES = {
    B1: { name: 'SOOTHE & REPAIR', tagline: 'Für reagierende und sensible Haut', soaps: ['KR'] },
    B2: { name: 'CLARIFY & BALANCE', tagline: 'Für Unreinheiten und Mischhaut', soaps: ['AK', 'TL', 'AV'] },
    B3: { name: 'NOURISH & RESTORE', tagline: 'Für trockene und dehydrierte Haut', soaps: ['KR', 'BO', 'SP'] },
    B4: { name: 'REVIVE & ENERGIZE', tagline: 'Für müde und fahle Haut', soaps: ['AV', 'RM', 'CT'] }
  };

  const PROBLEM_TO_OUTCOME = { P1: 'B1', P2: 'B2', P3: 'B3', P4: 'B4' };

  function parseBodyValue(value) {
    if (!value || value === 'NEUTRAL' || value === 'ZERO') return {};
    const result = {};
    value.split('.').forEach(pair => {
      const [code, val] = pair.split('_');
      if (code && val) result[code] = parseFloat(val);
    });
    return result;
  }

  function computeBodyOutcome(bodyAnswers) {
    const scores = { P1: 0, P2: 0, P3: 0, P4: 0, T1: 0, T2: 0, T3: 0, T4: 0 };
    let f1WinnerHint = null;
    Object.entries(bodyAnswers).forEach(([qid, value]) => {
      const parsed = parseBodyValue(value);
      Object.entries(parsed).forEach(([code, val]) => {
        if (scores[code] !== undefined) scores[code] += val;
      });
      if (qid === 'bf1') {
        const probMatch = value.match(/^(P[1-4])_/);
        if (probMatch) f1WinnerHint = probMatch[1];
      }
    });
    const problemScores = { P1: scores.P1, P2: scores.P2, P3: scores.P3, P4: scores.P4 };
    const maxScore = Math.max(...Object.values(problemScores));
    const winners = Object.entries(problemScores).filter(([_, s]) => s === maxScore).map(([p]) => p);
    let selectedProblem;
    if (maxScore === 0) selectedProblem = 'P3';
    else if (winners.length === 1) selectedProblem = winners[0];
    else if (f1WinnerHint && winners.includes(f1WinnerHint)) selectedProblem = f1WinnerHint;
    else {
      const hauttypMax = Math.max(scores.T1, scores.T2, scores.T3, scores.T4);
      const hauttypWinner = ['T1','T2','T3','T4'].find(t => scores[t] === hauttypMax);
      if ((hauttypWinner === 'T2' || hauttypWinner === 'T3') && winners.includes('P2')) selectedProblem = 'P2';
      else if ((hauttypWinner === 'T1' || hauttypWinner === 'T4') && winners.includes('P3')) selectedProblem = 'P3';
      else selectedProblem = 'P3';
    }
    return {
      outcomeId: PROBLEM_TO_OUTCOME[selectedProblem],
      outcome: BODY_OUTCOMES[PROBLEM_TO_OUTCOME[selectedProblem]]
    };
  }

  function renderBodyResult(outcomeResult) {
    const headline = document.getElementById('cart-quiz-body-result-headline');
    const message = document.getElementById('cart-quiz-body-result-message');
    const soapsContainer = document.getElementById('cart-quiz-body-soaps');
    const ctaWrap = document.getElementById('cart-quiz-body-cta-wrap');

    // BODY-SINGLE-SOAP-V1-MARKER (variant-e Slot E, Joshua 15.06.):
    // Body-Quiz-Result zeigt nur TOP-1 Empfehlung als Primary-Card.
    // Andere Seifen werden als kleinere "Add-On" Cards mit + Hinzufuegen Button gezeigt.
    // Ziel: Entscheidungslast senken, Funnel-Throughput erhoehen.
    headline.innerHTML = `Deine Top-Empfehlung:<br><span style="color:#d4af37; font-size:26px;">${outcomeResult.outcome.name}</span>`;
    const isBodyFirst = window.__bodyFirstMode === true;
    message.innerHTML = `<div class='result-hero-text'>${outcomeResult.outcome.tagline}.</div>
      <div class="result-scarcity-notice" style="background:#fdfaf2; border:1px solid #d4af37; color:#111; padding:12px; border-radius:8px; margin: 18px 0; text-align:center; font-weight:600; font-size:14px;">
         ${isBodyFirst 
           ? 'Diese Körperseife<span class="lq-gift-val"></span> <strong>GRATIS</strong> bei Einkauf einer Haarseifen-Box.'
           : 'Diese Körperseife<span class="lq-gift-val"></span> gehört <strong>GRATIS</strong> zu deiner Box.'}
      </div>`;

    /* QUIZ-VALUE-V10: Wert der empfohlenen Gratis-Seife (aufgeloeste Variante) anzeigen */
    (async function () {
      try {
        const lqCode = outcomeResult.outcome.soaps[0];
        const lqId = await lqResolveSoapId(BODY_SOAPS[lqCode].variantId);
        const lqP = await lqFetchSoap(BODY_SOAPS[lqCode].handle);
        const lqV = lqP && lqP.variants && lqP.variants.find(x => String(x.id) === String(lqId));
        const lqEl = document.querySelector('#cart-quiz-body-result .lq-gift-val');
        if (lqV && lqV.price && lqEl) lqEl.textContent = ' (Wert ' + ritualFmt(lqV.price) + ')';
      } catch (e) {}
    })();
    // BODY-SINGLE-SOAP-V1: Split outcome.soaps in primary (top 1) + optional addons
    const allSoaps = outcomeResult.outcome.soaps;
    const soapCodes = allSoaps.slice(0, 1);  // primary only
    const addonCodes = allSoaps.slice(1);    // rest = optional add-ons
    // BODY-RESET-V5-MARKER: GRATIS-Badge konditional auf erste Karte (in beiden Flows)
    soapsContainer.innerHTML = soapCodes.map((code, idx) => {
      const soap = BODY_SOAPS[code];
      const isFree = idx === 0;
      const badgeLabel = isBodyFirst && isFree ? 'GRATIS<br><span style="font-size:9px; font-weight:600;">bei Box-Kauf</span>' : 'GRATIS';
      const badgeHeight = isBodyFirst && isFree ? 'auto' : 'auto';
      const badgePadding = isBodyFirst && isFree ? '5px 10px' : '3px 10px';
      return `
        <div class="body-soap-card" style="display:flex; align-items:center; gap:14px; background:#fff; border:1.5px solid ${isFree ? '#d4af37' : '#eaeaea'}; border-radius:12px; padding:14px; margin-bottom:10px; position:relative;">
          ${isFree ? `<div style="position:absolute; top:-10px; right:14px; background:#d4af37; color:#fff; padding:${badgePadding}; border-radius:12px; font-size:11px; font-weight:700; text-align:center; line-height:1.2;">${badgeLabel}</div>` : ''}
          <img id="body-soap-img-${code}" src="" alt="${soap.title}" width="64" height="64" style="width:64px; height:64px; object-fit:cover; border-radius:8px; background:#f5f5f5;" loading="lazy" />
          <div style="flex:1; text-align:left;">
            <div style="font-weight:600; font-size:14px; color:#111; line-height:1.3;">${soap.title}</div>
            <div style="font-size:12px; color:#777; margin-top:2px;">${soap.subtitle}</div>
          </div>
        </div>
      `;
    }).join('');

    soapCodes.forEach(code => {
      const soap = BODY_SOAPS[code];
      fetch(`/products/${soap.handle}.js`).then(r => r.json()).then(p => {
        const img = document.getElementById(`body-soap-img-${code}`);
        if (img && p.featured_image) img.src = p.featured_image;
      }).catch(() => {});
    });

    // BODY-SINGLE-SOAP-V1: Render optional Add-On Section
    if (addonCodes.length > 0) {
      const addonContainer = document.createElement('div');
      addonContainer.id = 'cart-quiz-body-addons';
      addonContainer.style.cssText = 'margin-top: 22px; padding-top: 18px; border-top: 1px dashed #e5e1d4;';
      addonContainer.innerHTML = '<div style="font-size: 12px; font-weight: 700; color: #6a6a6a; text-transform: uppercase; letter-spacing: 0.8px; margin-bottom: 12px; text-align: center;">Passt zusätzlich zu deinem Profil</div>'
        + addonCodes.map(code => {
          const soap = BODY_SOAPS[code];
          return `<div class="body-soap-addon-card" data-soap-code="${code}" data-variant-id="${soap.variantId}" style="display:flex; align-items:center; gap:12px; background:#fafaf6; border:1px solid #ebe6d4; border-radius:10px; padding:10px 12px; margin-bottom:8px;">
            <img id="body-soap-addon-img-${code}" src="" alt="${soap.title}" width="48" height="48" style="width:48px; height:48px; object-fit:cover; border-radius:6px; background:#f0eee5;" loading="lazy" />
            <div style="flex:1; text-align:left;">
              <div style="font-weight:600; font-size:13px; color:#1a1a1a; line-height:1.3;">${soap.title}</div>
              <div style="font-size:11px; color:#777; margin-top:2px;">${soap.subtitle}</div>
            </div>
            <button class="body-soap-addon-btn" data-variant-id="${soap.variantId}" style="background:#fff; color:#d4af37; border:1.5px solid #d4af37; padding:8px 12px; border-radius:8px; font-size:12px; font-weight:700; cursor:pointer; white-space:nowrap;">+ Dazu</button>
          </div>`;
        }).join('');
      soapsContainer.parentNode.insertBefore(addonContainer, soapsContainer.nextSibling);

      addonCodes.forEach(code => {
        const soap = BODY_SOAPS[code];
        fetch(`/products/${soap.handle}.js`).then(r => r.json()).then(p => {
          const img = document.getElementById(`body-soap-addon-img-${code}`);
          if (img && p.featured_image) img.src = p.featured_image;
        }).catch(() => {});
      });

      // Click-Handler: + Dazu → addon-button toggle (selected state, fügt variant zu lokaler addon-Liste)
      addonContainer.querySelectorAll('.body-soap-addon-btn').forEach(btn => {
        btn.addEventListener('click', function(ev) {
          ev.preventDefault();
          ev.stopPropagation();
          const isSelected = btn.classList.toggle('selected');
          if (isSelected) {
            btn.style.background = '#d4af37';
            btn.style.color = '#fff';
            btn.textContent = '✓ Dazu';
            btn.closest('.body-soap-addon-card').style.borderColor = '#d4af37';
            btn.closest('.body-soap-addon-card').style.background = '#fdfaf2';
          } else {
            btn.style.background = '#fff';
            btn.style.color = '#d4af37';
            btn.textContent = '+ Dazu';
            btn.closest('.body-soap-addon-card').style.borderColor = '#ebe6d4';
            btn.closest('.body-soap-addon-card').style.background = '#fafaf6';
          }
          // Update variantIdsStr global for current CTA buttons
          const selectedAddonIds = Array.from(addonContainer.querySelectorAll('.body-soap-addon-btn.selected')).map(b => b.getAttribute('data-variant-id'));
          const allIds = [BODY_SOAPS[soapCodes[0]].variantId.toString(), ...selectedAddonIds];
          // Update all current CTAs that hold data-body-soaps
          document.querySelectorAll('#cart-quiz-body-take-now, #cart-quiz-body-to-hair, #cart-quiz-body-multi-add').forEach(b => {
            b.setAttribute('data-body-soaps', allIds.join(','));
          });
        });
      });
    }

    // BODY-RESET-V4-MARKER: Conditional CTA — bodyFirstMode → Hair-Quiz start; sonst direkt Cart-Add
    const numSoaps = soapCodes.length;
    const variantIdsStr = soapCodes.map(c => BODY_SOAPS[c].variantId).join(',');
    const bodyFirstActive = window.__bodyFirstMode === true;
    
    if (bodyFirstActive) {
      // BODY-RESET-V53-MARKER: TWO-BUTTON-CHOICE — Take-Now vs. Gratis-mit-Box
      // Joshua-Anforderung 15.06.: User soll Wahl haben zwischen
      // (a) Bündel SOFORT in Cart packen + Hair-Quiz danach
      // (b) Eine Seife GRATIS mit Box (warten bis Box-Add, dann merge)
      const labelTakeNow = numSoaps === 1
        ? 'Diese Körperseife übernehmen — direkt in den Warenkorb'
        : `${numSoaps} Körperseifen übernehmen — direkt in den Warenkorb`;
      const labelFreeWithBox = numSoaps === 1
        ? 'Diese GRATIS mit Haarseifen-Box'
        : 'Eine davon GRATIS mit Haarseifen-Box';
      const microFreeWithBox = numSoaps === 1
        ? 'Erst Hair-Quiz machen — am Ende kommt deine Körperseife automatisch GRATIS mit der Box dazu.'
        : `Erst Hair-Quiz machen — am Ende kommt eine deiner ${numSoaps} Körperseifen automatisch GRATIS mit der Box dazu, die anderen ergänzen deine Routine.`;
      ctaWrap.innerHTML = `
        <!-- BODY-RESET-V54-MARKER: Primary Button (vertauscht 15.06. 15:10) — Gratis-mit-Box (Optimiert auf Box-Verkauf) -->
        <button class="cta-winner" id="cart-quiz-body-to-hair"
                data-body-soaps="${variantIdsStr}"
                style="width:100%; margin-bottom:8px;">
          ${labelFreeWithBox}
        </button>
        <p style="margin: 0 0 18px 0; font-size:12px; color:#777; line-height:1.4; text-align:center;">${microFreeWithBox}</p>

        <!-- BODY-RESET-V54-MARKER: Secondary Button — Take-Now (One-Click ATC, niedrigerer AOV) -->
        <button class="cta-winner" id="cart-quiz-body-take-now"
                data-body-soaps="${variantIdsStr}"
                style="width:100%; padding:16px; background:#fff !important; color:#d4af37 !important; border:2px solid #d4af37; border-radius:12px; font-weight:700; font-size:15px; cursor:pointer;">
          ${labelTakeNow}
        </button>
        <p style="margin-top:10px; font-size:12px; color:#777; line-height:1.4; text-align:center;">Wird sofort hinzugefügt — danach findest du im Hair-Quiz deine passende Box.</p>
      `;

      // ----- Button 1: TAKE-NOW (One-Click Cart-Add + Hair-Quiz danach) -----
      document.getElementById('cart-quiz-body-take-now').addEventListener('click', async function() {
        const btn = this;
        const originalLabel = btn.innerHTML;
        btn.innerHTML = 'Wird hinzugefügt...';
        btn.style.pointerEvents = 'none';
        btn.style.opacity = '0.7';
        let bodyVars = btn.getAttribute('data-body-soaps').split(',');
        if (typeof window.__lqResolveSoapIds === 'function') { try { bodyVars = await window.__lqResolveSoapIds(bodyVars); } catch (e) {} } /* QUIZ-FIX-V9 */
        const items = bodyVars.map(v => ({ id: parseInt(v), quantity: 1 }));
        try {
          const resp = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
          if (!resp.ok) throw new Error('Add to cart failed');
          // BODY-RESET-V53-MARKER: Body-Soaps sind jetzt im Cart — kein pendingBodyCombo nötig.
          // __bodyFirstMode wird auf false gesetzt, damit Hair-Quiz-Box-Add NICHT noch eine Combo nachschiebt
          // und damit das Hair-Result KEIN "GRATIS bei Box-Kauf" Wording mehr hat.
          window.__bodyFirstMode = false;
          window.__bodyFirstModeRequested = false;
          try { localStorage.removeItem('pendingBodyCombo'); } catch(e) {}
          if (typeof window.updateCartCount === 'function') window.updateCartCount();
          if (typeof window.__loonaCartSync === 'function') window.__loonaCartSync(); /* V7.2 */
          // Body-Phase ausblenden
          document.querySelectorAll('.body-quiz-step, #cart-quiz-body-bridge, #cart-quiz-body-result').forEach(el => {
            el.style.display = 'none';
          });
          // Hair-Quiz Step 1 anzeigen
          const step1 = document.getElementById('cart-quiz-step-1');
          if (step1) step1.style.display = 'block';
          const progressText = document.getElementById('cart-quiz-progress-text');
          if (progressText) progressText.textContent = 'Frage 1 von 6';
          document.querySelectorAll('.svg-progress-fill').forEach(rect => rect.style.width = '0%');
          const progressWrapper = document.querySelector('#cart-quiz-progress-wrapper');
          if (progressWrapper) progressWrapper.style.display = 'block';
          // Modal-Scroll oben
          const modalContent = document.querySelector('.cart-quiz-content');
          if (modalContent) modalContent.scrollTop = 0;
        } catch (e) {
          btn.innerHTML = 'Hat nicht geklappt — bitte nochmal tippen';
          btn.style.pointerEvents = 'auto';
          btn.style.opacity = '1';
          setTimeout(() => { btn.innerHTML = originalLabel; }, 2500);
        }
      });

      // ----- Button 2: GRATIS-WITH-BOX (pendingBodyCombo-Pfad, bisheriges V5.2 Verhalten) -----
      document.getElementById('cart-quiz-body-to-hair').addEventListener('click', function() {
        const bodyVars = this.getAttribute('data-body-soaps').split(',');
        // BODY-RESET-V51-MARKER: BUG-FIX #3 — pendingBodyCombo mit TTL (30min) gegen Stale-Carry-Over
        try { 
          localStorage.setItem('pendingBodyCombo', JSON.stringify({
            variants: bodyVars,
            expiresAt: Date.now() + 30 * 60 * 1000
          })); 
        } catch(e) {}
        // Body-Phase ausblenden
        document.querySelectorAll('.body-quiz-step, #cart-quiz-body-bridge, #cart-quiz-body-result').forEach(el => {
          el.style.display = 'none';
        });
        // Hair-Quiz Step 1 anzeigen
        const step1 = document.getElementById('cart-quiz-step-1');
        if (step1) step1.style.display = 'block';
        const progressText = document.getElementById('cart-quiz-progress-text');
        if (progressText) progressText.textContent = 'Frage 1 von 6';
        document.querySelectorAll('.svg-progress-fill').forEach(rect => rect.style.width = '0%');
        const progressWrapper = document.querySelector('#cart-quiz-progress-wrapper');
        if (progressWrapper) progressWrapper.style.display = 'block';
        // Modal-Scroll oben
        const modalContent = document.querySelector('.cart-quiz-content');
        if (modalContent) modalContent.scrollTop = 0;
        // bodyFirstMode flag bleibt true — Hair-Quiz weiß damit dass Combo schon im localStorage liegt
      });
    } else {
      // Standard-Flow (Hair-First): Direkt Cart-Add der Combo
      const ctaLabel = numSoaps === 1 
        ? `Diese Körperseife dazu in den Warenkorb`
        : `${numSoaps} Körperseifen dazu in den Warenkorb`;
      ctaWrap.innerHTML = `
        <button class="cta-winner" id="cart-quiz-body-multi-add" 
                data-body-soaps="${variantIdsStr}"
                style="width:100%;">
          ${ctaLabel}
        </button>
        <button class="cart-quiz-option-btn" id="cart-quiz-body-finish" style="margin-top:10px; border:1.5px solid #eaeaea; background:#fff; cursor:pointer; width:100%;">
          <span class="cart-quiz-option-label" style="color:#666;">${window.__loonaTier === '3' ? 'Ohne Körperseife weiter' : 'Nein danke — direkt zum Warenkorb'}</span>
        </button>
      `;
      
      /* QUIZ-FIX-V9 (Joshua-Befund 28.09.): keine Sackgasse mehr. Varianten werden vor dem Add aufgeloest;
         klappt der Add trotzdem nicht, geht der Flow weiter (Oel-Check -> Schale/Reisebox). */
      const lqNext = function () {
        const ritualCfg = window.__loonaRitualConfig || {};
        if (typeof window.__showOilStep === 'function') { window.__showOilStep(); }
        else if (ritualCfg.ritualEnabled && typeof window.__showRitualStep === 'function') { window.__showRitualStep(); }
        else { window.location.href = '/cart'; }
      };
      const lqAdd = function (ids) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: ids.map(v => ({ id: parseInt(v), quantity: 1 })) })
        }).then(r => r.ok).catch(() => false);
      };
      document.getElementById('cart-quiz-body-multi-add').addEventListener('click', async function() {
        const btn = this;
        btn.textContent = 'Wird hinzugefügt …';
        btn.disabled = true;
        let bodyVars = btn.getAttribute('data-body-soaps').split(',');
        if (typeof window.__lqResolveSoapIds === 'function') { try { bodyVars = await window.__lqResolveSoapIds(bodyVars); } catch (e) {} }
        let ok = bodyVars.length > 0 && await lqAdd(bodyVars);
        if (!ok && bodyVars.length > 1) {
          // einzeln nachlegen: eine blockierte Seife darf die anderen nicht mitreissen
          for (const v of bodyVars) { if (await lqAdd([v])) ok = true; }
        }
        if (ok) {
          if (typeof window.updateCartCount === 'function') window.updateCartCount();
          if (typeof window.__loonaCartSync === 'function') window.__loonaCartSync(); /* V7.2 */
          lqNext();
        } else {
          btn.textContent = 'Diese Seife ist gerade vergriffen — weiter zu deinem Ritual';
          setTimeout(lqNext, 1400);
        }
      });

      document.getElementById('cart-quiz-body-finish').addEventListener('click', () => {
        /* QUIZ-FIX-V9: Stufe 3 = Komplett-Ritual -> ohne Seife trotzdem weiter zur Schale/Reisebox */
        if (window.__loonaTier === '3') { lqNext(); return; }
        window.location.href = '/cart';
      });
    }
    lqSoldOutCheck(outcomeResult, soapCodes, addonCodes); /* QUIZ-SOLDOUT-V11 */
  }

  // V3: HARD-hide function for clean focus on Body-Quiz
  function hideHairResult() {
    const step7 = document.getElementById('cart-quiz-step-7');
    const bridge = document.getElementById('cart-quiz-body-bridge');
    if (step7) {
      step7.style.display = 'none';
      step7.style.visibility = 'hidden';
      step7.style.height = '0';
      step7.style.overflow = 'hidden';
      /* RITUAL-STUFEN-V6.6 BUG-FIX (Joshua 07.08.): step7.innerHTML NICHT mehr leeren!
         Das zerstörte #cart-quiz-result-headline/-message/-product dauerhaft —
         jeder Quiz-Durchlauf nach dem ersten endete ohne sichtbares Ergebnis.
         Die Hide-Styles oben verhindern Leftover-Interaktion bereits vollständig. */
    }
    if (bridge) {
      bridge.style.display = 'none';
      bridge.style.visibility = 'hidden';
      bridge.style.height = '0';
      bridge.style.overflow = 'hidden';
    }
    // V3: Reset modal scroll-position WITHOUT smooth animation
    const modalContent = document.querySelector('.cart-quiz-content');
    if (modalContent) {
      const prevBehavior = modalContent.style.scrollBehavior;
      modalContent.style.scrollBehavior = 'auto';
      modalContent.scrollTop = 0;
      // restore later
      setTimeout(() => { modalContent.style.scrollBehavior = prevBehavior || ''; }, 50);
    }
  }

  window.__triggerBodyBridge = function() {
    const bridge = document.getElementById('cart-quiz-body-bridge');
    if (!bridge) return;
    /* QUIZ-FIX-V9 (Joshua 28.09.): Nach dem Box-Add verschwindet das Box-Ergebnis samt Oel-Wahl.
       Vorher blieb "Dein Ritual - deine Wahl" ueber der Gratis-Seife stehen und das Oel liess sich
       wieder abwaehlen. Jetzt: direkt und allein weiter zur Gratis-Koerperseife. */
    const lqStep7 = document.getElementById('cart-quiz-step-7');
    if (lqStep7) lqStep7.style.display = 'none';
    const lqSub = document.getElementById('lq-bridge-sub');
    if (lqSub && document.querySelector('.js-cart-quiz-add-btn[data-oil-added="true"]')) {
      lqSub.innerHTML = 'Box und Öl sind im Warenkorb — damit gehört eine Körperseife <strong>GRATIS</strong> dazu. Finde in <strong>5 Fragen</strong> die passende oder such sie dir einfach selbst aus.';
    }
    const lqSkip = document.querySelector('#cart-quiz-skip-body .cart-quiz-option-label');
    if (lqSkip) lqSkip.textContent = window.__loonaTier === '3' ? 'Ohne Körperseife weiter' : 'Zum Warenkorb (überspringen)';
    bridge.style.display = 'block';
    const modalContent = document.querySelector('.cart-quiz-content');
    if (modalContent) {
      const prevBehavior = modalContent.style.scrollBehavior;
      modalContent.style.scrollBehavior = 'auto';
      modalContent.scrollTop = 0;
      setTimeout(() => { modalContent.style.scrollBehavior = prevBehavior || ''; }, 50);
    }
  };

  function initBodyQuiz() {
    const bridge = document.getElementById('cart-quiz-body-bridge');
    const startBtn = document.getElementById('cart-quiz-start-body');
    const skipBtn = document.getElementById('cart-quiz-skip-body');
    if (!bridge || !startBtn) return;

    // RITUAL-STUFEN-V6: "Selbst aussuchen"-Link aus der Section-Config
    const pickBtn = document.getElementById('cart-quiz-pick-body');
    if (pickBtn && window.__loonaRitualConfig && window.__loonaRitualConfig.bodyCollectionUrl) {
      pickBtn.href = window.__loonaRitualConfig.bodyCollectionUrl;
    }

    const bodyAnswers = {};

    if (skipBtn) skipBtn.addEventListener('click', () => {
      /* QUIZ-FIX-V9: Stufe 3 = Komplett-Ritual -> ohne Seife trotzdem weiter (Oel-Check -> Schale/Reisebox) */
      if (window.__loonaTier === '3' && typeof window.__showOilStep === 'function') { window.__showOilStep(); return; }
      window.location.href = '/cart';
    });

    startBtn.addEventListener('click', () => {
      // V3: HARD-hide upper section + reset scroll
      hideHairResult();
      const step1 = document.getElementById('cart-quiz-body-step-1');
      if (step1) step1.style.display = 'block';
      const progressText = document.getElementById('cart-quiz-progress-text');
      if (progressText) progressText.textContent = 'Body-Reset Frage 1 von 5';
      const progressFill = document.querySelector('.svg-progress-fill');
      if (progressFill) progressFill.setAttribute('width', '20%');
    });

    document.querySelectorAll('.body-quiz-step .cart-quiz-option-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        const qid = this.getAttribute('data-question-id');
        const value = this.getAttribute('data-quiz-value');
        if (!qid) return;
        bodyAnswers[qid] = value;
        const stepEl = this.closest('.cart-quiz-step');
        const stepNum = parseInt(stepEl.id.replace('cart-quiz-body-step-', ''));
        document.querySelectorAll('.body-quiz-step .cart-quiz-option-btn.selected').forEach(b => b.classList.remove('selected'));
        this.classList.add('selected');

        setTimeout(() => {
          stepEl.style.display = 'none';
          // V3: Reset scroll on step-change WITHOUT smooth animation
          const modalContent = document.querySelector('.cart-quiz-content');
          if (modalContent) {
            const prev = modalContent.style.scrollBehavior;
            modalContent.style.scrollBehavior = 'auto';
            modalContent.scrollTop = 0;
            setTimeout(() => { modalContent.style.scrollBehavior = prev || ''; }, 50);
          }
          if (stepNum < 5) {
            const nextStep = document.getElementById(`cart-quiz-body-step-${stepNum + 1}`);
            if (nextStep) {
              nextStep.style.display = 'block';
              const progressText = document.getElementById('cart-quiz-progress-text');
              if (progressText) progressText.textContent = `Body-Reset Frage ${stepNum + 1} von 5`;
              const progressFill = document.querySelector('.svg-progress-fill');
              if (progressFill) progressFill.setAttribute('width', `${(stepNum + 1) * 20}%`);
            }
          } else {
            const result = computeBodyOutcome(bodyAnswers);
            document.getElementById('cart-quiz-body-result').style.display = 'block';
            const progressText = document.getElementById('cart-quiz-progress-text');
            if (progressText) progressText.textContent = 'Dein Body-Reset';
            const progressFill = document.querySelector('.svg-progress-fill');
            if (progressFill) progressFill.setAttribute('width', '100%');
            renderBodyResult(result);
          }
        }, 250);
      });
    });
  }

  /* ==================================================================
     RITUAL-STUFEN-V6: Stufe 4 — Komplett-Ritual Engine
     Schalen-Wahl (nur verfügbare Schalen), Sisal gratis, Ersparnis-
     Rechnung live aus cart.js (echte Preise, keine erfundenen Anker).
     Fail-safe: jeder Fehlerpfad endet im Warenkorb, nie in Sackgasse.
     ================================================================== */
  function ritualFmt(cents) {
    return new Intl.NumberFormat((window.Shopify && window.Shopify.locale) || 'de-DE', { style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR' }).format(cents / 100);
  }

  async function ritualFetchProduct(handle) {
    if (!handle) return null;
    try {
      const r = await fetch(`/products/${handle}.js`);
      if (!r.ok) return null;
      return await r.json();
    } catch (e) { return null; }
  }

  /* ==================================================================
     RITUAL-STUFEN-V6.6 (Joshua 07.08.): Stufe 2 IM FLUSS — das Öl kommt
     jetzt NACH der Körperseife und VOR der Schale. Selbst-deaktivierend:
     Öl DRAFT/404/ausverkauft ODER schon im Warenkorb (Toggle am
     Box-Ergebnis) → Schritt wird still übersprungen, Flow geht direkt
     zur Schalen-Stufe. Ab Produktaktivierung (Launch 15.08.) erscheint
     er automatisch. Jeder Fehlerpfad endet in der Schalen-Stufe.
     ================================================================== */
  window.__showOilStep = async function () {
    const cfg = window.__loonaRitualConfig || {};
    const step = document.getElementById('cart-quiz-oil-step');
    const goRitual = function () {
      if (cfg.ritualEnabled && typeof window.__showRitualStep === 'function') { window.__showRitualStep(); }
      else { window.location.href = '/cart'; }
    };
    if (!cfg.oilEnabled || !cfg.oilHandle || !step) { goRitual(); return; }
    let oil = null;
    try {
      const r = await fetch(`/products/${cfg.oilHandle}.js`);
      if (!r.ok) { goRitual(); return; } // DRAFT oder gelöscht → überspringen
      oil = await r.json();
    } catch (e) { goRitual(); return; }
    const oilVariant = (oil.variants || []).find(v => v.available);
    if (!oilVariant) { goRitual(); return; } // ausverkauft → überspringen
    /* V7.2 (Joshua-Test 10.08.): "Einmal angenommen wird nicht nochmal gepitcht."
       Vorher zeigte ein stiller /cart.js-Fehler den Pitch BLIND — auch wenn das Öl längst
       im Warenkorb lag. Jetzt: (1) Öl im Cart → skip. (2) Öl-Wahl war gefallen (Toggle am
       Box-Ergebnis), fehlt aber im Cart → still nachlegen statt erneut fragen; nachgelegt
       wird NUR bei sicher gelesenem Warenkorb (sonst Doppel-Add-Risiko), sonst nur skip. */
    let oilInCart = false, cartKnown = false;
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      cartKnown = true;
      oilInCart = (cart.items || []).some(i => i.handle === cfg.oilHandle);
    } catch (e) {}
    if (oilInCart) { goRitual(); return; } // Öl ist schon drin
    if (window.__loonaOilChoice === 'taken') {
      if (cartKnown) {
        try {
          const addResp = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [window.__lfcOilItem(oilVariant.id, window.__lfComboBox)] })
          });
          if (addResp.ok && typeof window.__loonaCartSync === 'function') window.__loonaCartSync();
        } catch (e) {}
      }
      goRitual(); return;
    }

    for (let i = 1; i <= 7; i++) {
      const el = document.getElementById('cart-quiz-step-' + i);
      if (el) el.style.display = 'none';
    }
    document.querySelectorAll('.body-quiz-step, #cart-quiz-body-bridge, #cart-quiz-body-result, #cart-quiz-ritual-step').forEach(el => { el.style.display = 'none'; });

    /* V6.8: Set-Vorteil erst versprechen, wenn der RITUAL-OEL-Rabatt aktiv ist (15.08. 00:00) —
       sonst zeigt die Kasse einen anderen Preis als der Quiz-Schritt. */
    const oilDiscountsLive = (Date.now() / 1000) >= (cfg.discountsLiveAtS || 0);
    const discount = oilDiscountsLive ? Math.min(cfg.oilDiscountCents || 0, oilVariant.price) : 0;
    const bundle = oilVariant.price - discount;
    document.getElementById('cart-quiz-oil-step-body').innerHTML = `
      <div style="display:flex; align-items:center; gap:14px; padding:16px; background:#fffdf6; border:1.5px solid #d4af37; border-radius:14px; text-align:left;">
        <img src="${oil.featured_image || ''}" alt="${(oil.title || '').replace(/"/g, '&quot;')}" loading="lazy" style="width:72px; height:72px; object-fit:cover; border-radius:10px; background:#f5f5f5; flex-shrink:0;" />
        <div style="flex:1;">
          <div style="font-weight:700; font-size:15px; color:#111; line-height:1.35;">Root &amp; Shine Hair Elixir (30 ml)</div>
          <div style="font-size:12px; color:#666; margin-top:3px; line-height:1.45;">Leichtes Haar&ouml;l f&uuml;r L&auml;ngen &amp; Spitzen &mdash; 100&nbsp;% nat&uuml;rlich, silikonfrei, beschwert nicht.</div>
          <div style="font-size:14px; margin-top:6px;">
            <strong style="color:#b08d2a;">${ritualFmt(bundle)}</strong>
            ${discount > 0 ? `<s style="color:#999; font-size:12px;">${ritualFmt(oilVariant.price)}</s> <span style="display:inline-block; white-space:nowrap; background:#d4af37; color:#fff; border-radius:8px; padding:1px 7px; font-size:11px; font-weight:700;">Nur im Set: &minus;${ritualFmt(discount)}</span>` : ''}
          </div>
          ${discount > 0 ? `<div style="font-size:11px; color:#8a7752; margin-top:3px;">Der Set-Vorteil wird im Warenkorb automatisch abgezogen.</div>` : ''}
        </div>
      </div>
      <div id="lq-oil-total" class="lq-oil-total" style="display:none;"></div>
      <button type="button" class="cta-winner" id="cart-quiz-oil-add" style="width:100%; margin-top:16px; padding:18px;">Elixier dazulegen &amp; weiter</button>
      <button type="button" class="cart-quiz-option-btn" id="cart-quiz-oil-skip" style="margin-top:10px; border:1.5px solid #eaeaea; background:#fff; cursor:pointer; width:100%;"><span class="cart-quiz-option-label" style="color:#666;">Ohne Elixier weiter</span></button>
      <div style="text-align:center; margin-top:12px;"><a href="/cart" style="font-size:13px; color:#888; text-decoration:underline;">Direkt zum Warenkorb</a></div>
    `;

    /* QUIZ-VALUE-V10: laufender Gesamtwert (Warenkorb + Elixier) im Oel-Schritt */
    (async function () {
      try {
        if (typeof window.__lqCartValue !== 'function') return;
        const lqCart = await fetch('/cart.js').then(r => r.json());
        const v = await window.__lqCartValue(lqCart);
        const full = v.full + oilVariant.price, pay = v.pay + bundle;
        const el = document.getElementById('lq-oil-total');
        if (el && full > pay) {
          el.innerHTML = 'Dein Ritual mit Elixier: Gesamtwert <s>' + ritualFmt(full) + '</s> — du zahlst <strong>' + ritualFmt(pay) + '</strong> und sparst <strong>' + ritualFmt(full - pay) + '</strong>.';
          el.style.display = 'block';
        }
      } catch (e) {}
    })();
    step.style.display = 'block';
    const progressTextOil = document.getElementById('cart-quiz-progress-text');
    if (progressTextOil) progressTextOil.textContent = 'Dein Ritual: Stufe 2 von 3';
    document.querySelectorAll('.svg-progress-fill').forEach(rect => { rect.style.width = '100%'; rect.setAttribute('width', '100%'); });
    const modalContentOil = document.querySelector('.cart-quiz-content');
    if (modalContentOil) {
      const prev = modalContentOil.style.scrollBehavior;
      modalContentOil.style.scrollBehavior = 'auto';
      modalContentOil.scrollTop = 0;
      setTimeout(() => { modalContentOil.style.scrollBehavior = prev || ''; }, 50);
    }

    document.getElementById('cart-quiz-oil-skip').addEventListener('click', function () {
      window.__loonaOilChoice = 'declined'; /* V7.2 */
      goRitual();
    });
    document.getElementById('cart-quiz-oil-add').addEventListener('click', async function () {
      const btn = this;
      btn.textContent = 'Wird hinzugefügt…';
      btn.disabled = true;
      try {
        const resp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [window.__lfcOilItem(oilVariant.id, window.__lfComboBox)] })
        });
        if (!resp.ok) throw new Error('add failed');
        window.__loonaOilChoice = 'taken'; /* V7.2 */
        if (typeof window.updateCartCount === 'function') window.updateCartCount();
        if (typeof window.__loonaCartSync === 'function') window.__loonaCartSync(); /* V7.2 */
        goRitual();
      } catch (e) {
        btn.disabled = false;
        btn.textContent = 'Hat nicht geklappt — bitte nochmal tippen';
      }
    });
  };

  window.__showRitualStep = function () {
    const cfg = window.__loonaRitualConfig || {};
    const step = document.getElementById('cart-quiz-ritual-step');
    if (!cfg.ritualEnabled || !step) { window.location.href = '/cart'; return; }
    for (let i = 1; i <= 7; i++) {
      const el = document.getElementById('cart-quiz-step-' + i);
      if (el) el.style.display = 'none';
    }
    document.querySelectorAll('.body-quiz-step, #cart-quiz-body-bridge, #cart-quiz-body-result, #cart-quiz-oil-step').forEach(el => { el.style.display = 'none'; });
    step.style.display = 'block';
    const progressText = document.getElementById('cart-quiz-progress-text');
    if (progressText) progressText.textContent = 'Letzter Schritt: dein Ritual';
    document.querySelectorAll('.svg-progress-fill').forEach(rect => { rect.style.width = '100%'; rect.setAttribute('width', '100%'); });
    const modalContent = document.querySelector('.cart-quiz-content');
    if (modalContent) {
      const prev = modalContent.style.scrollBehavior;
      modalContent.style.scrollBehavior = 'auto';
      modalContent.scrollTop = 0;
      setTimeout(() => { modalContent.style.scrollBehavior = prev || ''; }, 50);
    }
    renderRitualStep().catch(() => { window.location.href = '/cart'; });
  };

  async function renderRitualStep() {
    const cfg = window.__loonaRitualConfig || {};
    const dishesEl = document.getElementById('cart-quiz-ritual-dishes');
    const sisalEl = document.getElementById('cart-quiz-ritual-sisal');
    const summaryEl = document.getElementById('cart-quiz-ritual-summary');
    const ctaEl = document.getElementById('cart-quiz-ritual-cta');
    if (!dishesEl || !ctaEl) { window.location.href = '/cart'; return; }
    dishesEl.innerHTML = '<p style="text-align:center; color:#888; font-size:14px;">Einen Moment …</p>';

    const handles = (cfg.dishHandles || []).filter(Boolean);
    /* CORK-V7.3: beliebig viele Schalen in Config-Reihenfolge (Cork, Naturton, StoneFlow …). */
    const [dishProducts, sisalP, cart] = await Promise.all([
      Promise.all(handles.map(h => ritualFetchProduct(h))),
      ritualFetchProduct(cfg.sisalHandle),
      fetch('/cart.js').then(r => r.json()).catch(() => null)
    ]);

    // Nur verfügbare Schalen anbieten (Naturton/StoneFlow haben kleinen Bestand → fallen ggf. automatisch raus)
    const dishOptions = dishProducts.map(p => {
      if (!p) return null;
      const v = (p.variants || []).find(vv => vv.available);
      return v ? { product: p, variant: v } : null;
    }).filter(Boolean);

    if (dishOptions.length === 0) { window.location.href = '/cart'; return; }

    /* V6.8: Rabatte nur versprechen, wenn sie im Warenkorb wirklich ankommen (GO-LIVE 15.08. 00:00).
       Vorher rechnete der Schritt mit Set-Preisen, die die Kasse noch nicht kannte (Joshua-Befund 07.08.:
       Quiz 84,95 € vs. Warenkorb 104,85 €). */
    const discountsLive = (Date.now() / 1000) >= (cfg.discountsLiveAtS || 0);

    /* V6.8: Schale schon im Warenkorb → Ritual ist komplett, Schritt überspringen (kein Doppel-Add). */
    if (cart && cart.items && cart.items.some(i => handles.indexOf(i.handle) !== -1)) { window.location.href = '/cart'; return; }

    let sisalVariant = sisalP ? (sisalP.variants || []).find(v => v.available) : null;
    if (sisalVariant && cart && cart.items && cart.items.some(i => i.handle === cfg.sisalHandle)) { sisalVariant = null; }
    /* V6.9 (Joshua 07.08.): Sisal ist DAS Stufe-3-Versprechen ("gratis dazu" wie auf der Startseite
       angeteasert) — GRATIS-Anzeige hängt nur am Setting, nicht am Rabatt-Gate. RITUAL-SISAL zieht
       ab 15.08. in der Kasse; das Theme geht erst mit dem Launch-Publish live. */
    const sisalIsFree = !!(cfg.sisalFree && sisalVariant);
    const dishDiscount = discountsLive ? Math.min(cfg.dishDiscountCents || 0, dishOptions[0].variant.price) : 0;

    /* V6.8 (Joshua 07.08.): Gesamtwert = jede Seife der Box EINZELN gerechnet (Großes Stück, ohne
       Schönheitsmakel-Varianten). Preise live aus /products/*.js; schlägt ein Fetch fehl, bleibt
       für diese Box der Box-Preis als ehrlicher Fallback. */
    const boxFullByHandle = {};
    try {
      const comps = cfg.boxComponents || {};
      const boxesInCart = (cart && cart.items ? cart.items : []).map(i => i.handle).filter(h => comps[h]);
      const compHandles = boxesInCart.reduce((acc, h) => {
        comps[h].forEach(c => { if (acc.indexOf(c.handle) === -1) acc.push(c.handle); });
        return acc;
      }, []);
      const compProducts = await Promise.all(compHandles.map(h => ritualFetchProduct(h)));
      const compByHandle = {};
      compHandles.forEach((h, i) => { compByHandle[h] = compProducts[i]; });
      boxesInCart.forEach(bh => {
        let sum = 0, ok = true;
        comps[bh].forEach(c => {
          const vs = (compByHandle[c.handle] && compByHandle[c.handle].variants) || [];
          const match = v => (!c.pct || (v.title || '').indexOf(c.pct) !== -1);
          let v = vs.find(vv => match(vv) && /Gro/.test(vv.title || '') && !/akel/.test(vv.title || ''));
          if (!v) v = vs.find(match);
          if (v && v.price) { sum += v.price; } else { ok = false; }
        });
        if (ok && sum > 0) boxFullByHandle[bh] = sum;
      });
    } catch (e) { /* Fallback: Box-Preis bleibt in buildTotals */ }

    const subEl = document.getElementById('cart-quiz-ritual-sub');
    if (subEl && !sisalVariant) {
      subEl.innerHTML = 'Naturseife hält doppelt so lange, wenn sie trocken liegt. Wähle deine Schale oder Reisebox für dein Ritual.';
    } else if (subEl && sisalVariant && !cfg.sisalFree) {
      subEl.innerHTML = 'Naturseife hält doppelt so lange, wenn sie trocken liegt. Wähle deine Schale oder Reisebox — und nimm das Sisal-Säckchen für Reststücke gleich mit.';
    }

    let selectedDishIdx = 0;

    function renderDishes() {
      dishesEl.innerHTML = '<div style="font-size:12px; font-weight:700; color:#6a6a6a; text-transform:uppercase; letter-spacing:0.8px; margin-bottom:12px; text-align:center;">Wähle deine Schale oder Reisebox</div>'
        + `<div class="cart-quiz-options--grid" style="display:grid; grid-template-columns:${dishOptions.length > 2 ? 'repeat(auto-fit, minmax(140px, 1fr))' : 'repeat(' + dishOptions.length + ', 1fr)'}; gap:12px;">`
        + dishOptions.map((opt, idx) => {
          const sel = idx === selectedDishIdx;
          const payPrice = Math.max(0, opt.variant.price - dishDiscount);
          return `<button type="button" class="cart-quiz-ritual-dish" data-dish-idx="${idx}" aria-pressed="${sel}" style="background:${sel ? '#fdfaf2' : '#fff'}; border:1.5px solid ${sel ? '#d4af37' : '#eaeaea'}; border-radius:14px; padding:14px 12px; cursor:pointer; text-align:center; position:relative; box-shadow:${sel ? '0 0 0 1px #d4af37' : 'none'};">
            ${sel ? '<div style="position:absolute; top:-10px; right:12px; background:#d4af37; color:#fff; padding:2px 10px; border-radius:10px; font-size:11px; font-weight:700;">✓ Deine Wahl</div>' : ''}
            <img src="${opt.product.featured_image || ''}" alt="${opt.product.title}" loading="lazy" style="width:100%; max-width:130px; height:auto; border-radius:10px; background:#f5f5f5;" />
            <div style="font-weight:600; font-size:13px; color:#111; margin-top:10px; line-height:1.3;">${opt.product.title}</div>
            <div style="font-size:13px; margin-top:6px;"><strong style="color:#b08d2a;">${ritualFmt(payPrice)}</strong>${dishDiscount > 0 ? ` <s style="color:#999; font-size:12px;">${ritualFmt(opt.variant.price)}</s>` : ''}</div>
            ${dishDiscount > 0 ? '<div style="font-size:11px; color:#b08d2a; font-weight:600; margin-top:2px;">Nur im Ritual</div>' : ''}
          </button>`;
        }).join('')
        + '</div>';
      dishesEl.querySelectorAll('.cart-quiz-ritual-dish').forEach(btn => {
        btn.addEventListener('click', () => {
          selectedDishIdx = parseInt(btn.getAttribute('data-dish-idx'), 10) || 0;
          renderDishes();
          renderSummary();
        });
      });
    }

    function renderSisal() {
      if (!sisalEl) return;
      if (!sisalVariant) { sisalEl.innerHTML = ''; return; }
      sisalEl.innerHTML = `
        <div style="display:flex; align-items:center; gap:12px; background:#fafaf6; border:1px solid ${sisalIsFree ? '#d4af37' : '#ebe6d4'}; border-radius:12px; padding:12px 14px; margin-top:14px; position:relative;">
          ${sisalIsFree ? '<div style="position:absolute; top:-10px; right:14px; background:#d4af37; color:#fff; padding:2px 10px; border-radius:10px; font-size:11px; font-weight:700;">GRATIS dazu</div>' : ''}
          <img src="${sisalP.featured_image || ''}" alt="${sisalP.title}" loading="lazy" style="width:48px; height:48px; object-fit:cover; border-radius:8px; background:#f0eee5;" />
          <div style="flex:1; text-align:left;">
            <div style="font-weight:600; font-size:13px; color:#111; line-height:1.3;">Sisal-Säckchen${sisalVariant.title && sisalVariant.title !== 'Default Title' ? ' · ' + sisalVariant.title : ''}</div>
            <div style="font-size:12px; color:#777; margin-top:2px;">Für Reststücke &amp; sanftes Peeling — nichts wird verschwendet.</div>
          </div>
          <div style="font-size:13px; font-weight:700; color:${sisalIsFree ? '#b08d2a' : '#111'}; white-space:nowrap;">${sisalIsFree ? `<s style="color:#999; font-weight:500;">${ritualFmt(sisalVariant.price)}</s> 0 €` : ritualFmt(sisalVariant.price)}</div>
        </div>`;
    }

    function buildTotals() {
      const rows = [];
      let fullCents = 0;
      let payCents = 0;
      if (cart && cart.items) {
        cart.items.forEach(item => {
          /* V6.8: Boxen zählen im Gesamtwert mit der Summe ihrer Einzelseifen (live gefetcht). */
          const unitFull = boxFullByHandle[item.handle] || item.original_price || item.price;
          const lineFull = unitFull * item.quantity;
          let lineFinal = (item.final_line_price !== undefined && item.final_line_price !== null) ? item.final_line_price : ((item.price || 0) * item.quantity);
          let note = '';
          // Öl-Set-Vorteil anzeigen, solange die Kasse ihn noch nicht selbst abzieht (Doppelzählung ausgeschlossen)
          if (discountsLive && item.handle === cfg.oilHandle && cfg.oilDiscountCents && lineFinal >= lineFull) {
            lineFinal = Math.max(0, lineFull - cfg.oilDiscountCents);
            note = 'Set-Vorteil';
          }
          if (lineFinal === 0) note = 'GRATIS';
          fullCents += lineFull;
          payCents += lineFinal;
          rows.push({ title: item.product_title + (item.quantity > 1 ? ' ×' + item.quantity : ''), pay: lineFinal, note });
        });
      }
      const dish = dishOptions[selectedDishIdx];
      const dishPay = Math.max(0, dish.variant.price - dishDiscount);
      fullCents += dish.variant.price;
      payCents += dishPay;
      rows.push({ title: dish.product.title, pay: dishPay, note: dishDiscount > 0 ? 'Ritual-Vorteil' : '' });
      if (sisalVariant) {
        fullCents += sisalVariant.price;
        payCents += sisalIsFree ? 0 : sisalVariant.price;
        rows.push({ title: 'Sisal-Säckchen', pay: sisalIsFree ? 0 : sisalVariant.price, note: sisalIsFree ? 'GRATIS' : '' });
      }
      return { rows, fullCents, payCents };
    }

    function renderSummary() {
      if (!summaryEl) return;
      const t = buildTotals();
      const saved = Math.max(0, t.fullCents - t.payCents);
      summaryEl.innerHTML = `
        <div style="margin-top:20px; background:#fffdf6; border:1px solid #e8d89e; border-radius:14px; padding:16px 18px; text-align:left;">
          <div style="font-size:12px; font-weight:700; color:#6b5b3a; text-transform:uppercase; letter-spacing:0.8px; margin-bottom:10px;">Dein Ritual im Überblick</div>
          ${t.rows.map(r => `<div style="display:flex; justify-content:space-between; gap:10px; font-size:13px; color:#333; margin-bottom:6px;">
            <span style="flex:1;">✓ ${r.title}${r.note ? ` <span style="color:#b08d2a; font-weight:700; font-size:11px;">${r.note}</span>` : ''}</span>
            <span style="font-weight:${r.pay === 0 ? '700' : '500'}; color:${r.pay === 0 ? '#b08d2a' : '#111'}; white-space:nowrap;">${r.pay === 0 ? '0 €' : ritualFmt(r.pay)}</span>
          </div>`).join('')}
          <div style="border-top:1px solid #eee3c0; margin-top:10px; padding-top:10px;">
            <div style="display:flex; justify-content:space-between; align-items:baseline; gap:10px; font-size:13px; color:#666;">
              <span>Gesamtwert &mdash; alles einzeln gekauft</span>
              <s style="font-size:17px; color:#999; white-space:nowrap;">${ritualFmt(t.fullCents)}</s>
            </div>
            <div style="display:flex; justify-content:space-between; align-items:baseline; gap:10px; margin-top:6px;">
              <span style="font-size:14px; font-weight:600; color:#111;">Dein Ritual komplett</span>
              <strong style="font-size:22px; color:#111; white-space:nowrap;">${ritualFmt(t.payCents)}</strong>
            </div>
            ${saved > 0 ? `<div style="margin-top:6px; text-align:right; font-size:13px; font-weight:700; color:#b08d2a;">Du sparst ${ritualFmt(saved)}</div>` : ''}
          </div>
          <div style="margin-top:8px; font-size:11px; color:#8a7752; font-style:italic;">Gesamtwert = Einzelpreise aller Produkte, jede Seife deiner Box einzeln gerechnet.${(dishDiscount > 0 || sisalIsFree) ? ' Alle Vorteile werden im Warenkorb automatisch abgezogen &mdash; kein Code n&ouml;tig.' : ''}</div>
        </div>`;
    }

    function renderCta() {
      const label = sisalVariant
        ? (sisalIsFree ? 'Ritual komplett in den Warenkorb — inkl. Gratis-Sisal' : 'Ritual komplett in den Warenkorb')
        : 'Schale dazu — Ritual komplett in den Warenkorb';
      ctaEl.innerHTML = `
        <button class="cta-winner" id="cart-quiz-ritual-add" style="width:100%;">${label}</button>
        <button class="cart-quiz-option-btn" id="cart-quiz-ritual-skip" style="margin-top:10px; border:1.5px solid #eaeaea; background:#fff; cursor:pointer; width:100%;">
          <span class="cart-quiz-option-label" style="color:#666;">Zum Warenkorb ohne Schale</span>
        </button>`;
      document.getElementById('cart-quiz-ritual-add').addEventListener('click', async function () {
        const btn = this;
        btn.innerHTML = 'Wird hinzugefügt …';
        btn.style.pointerEvents = 'none';
        btn.style.opacity = '0.7';
        const items = [{ id: dishOptions[selectedDishIdx].variant.id, quantity: 1 }];
        if (sisalVariant) items.push({ id: sisalVariant.id, quantity: 1 });
        try {
          const resp = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
          if (!resp.ok) throw new Error('Add to cart failed');
          window.location.href = '/cart';
        } catch (e) {
          btn.innerHTML = 'Hat nicht geklappt — bitte nochmal tippen';
          btn.style.pointerEvents = 'auto';
          btn.style.opacity = '1';
        }
      });
      document.getElementById('cart-quiz-ritual-skip').addEventListener('click', () => { window.location.href = '/cart'; });
    }

    renderDishes();
    renderSisal();
    renderSummary();
    renderCta();
  }
  // END RITUAL-STUFEN-V6 Engine

  // BODY-RESET-V5-MARKER: Body-First-Flow Trigger (über Click-Handler ODER hash/URL-Param)
  window.__triggerBodyFirstMode = function() {
    runBodyFirstModeLogic();
  };
  function runBodyFirstModeLogic() {
    fetch('/cart.js').then(r => r.json()).then(cart => {
        const hasBox = cart.items.some(item => 
          item.product_title && item.product_title.toLowerCase().includes('box')
        );
        if (hasBox) {
          // Box schon im Cart → direkt zur Body-Bridge (simulierter box-added state)
          window.__loonaBoxAdded = true;
          setTimeout(() => {
            for (let i = 1; i <= 7; i++) {
              const step = document.getElementById('cart-quiz-step-' + i);
              if (step) step.style.display = 'none';
            }
            const bridge = document.getElementById('cart-quiz-body-bridge');
            if (bridge) bridge.style.display = 'block';
            const progressText = document.getElementById('cart-quiz-progress-text');
            if (progressText) progressText.textContent = 'Body-Reset bereit';
          }, 500);
        } else {
          // BODY-RESET-V4-MARKER: Body-First-Flow → START mit Body-Quiz Step 1
          window.__bodyFirstMode = true;
          setTimeout(() => {
            // Hide alle Hair-Quiz Steps + Body-Bridge
            for (let i = 1; i <= 7; i++) {
              const step = document.getElementById('cart-quiz-step-' + i);
              if (step) step.style.display = 'none';
            }
            const bridge = document.getElementById('cart-quiz-body-bridge');
            if (bridge) bridge.style.display = 'none';
            // Show Body-Quiz Step 1
            const bodyStep1 = document.getElementById('cart-quiz-body-step-1');
            if (bodyStep1) bodyStep1.style.display = 'block';
            const progressText = document.getElementById('cart-quiz-progress-text');
            if (progressText) progressText.textContent = 'Körperseife Frage 1 von 5';
            document.querySelectorAll('.svg-progress-fill').forEach(rect => rect.setAttribute('width', '20%'));
            const progressWrapper = document.querySelector('#cart-quiz-progress-wrapper');
            if (progressWrapper) progressWrapper.style.display = 'block';
          }, 500);
        }
    }).catch(() => {});
  }
  
  // BODY-RESET-V5-MARKER: Backwards-compat: bei page-load mit ?quiz=body im URL → trigger
  function checkBodyQuizMode() {
    const params = new URLSearchParams(window.location.search);
    const hashMode = window.location.hash.includes('quiz=body');
    if (params.get('quiz') === 'body' || hashMode) {
      window.__bodyFirstModeRequested = true;
      runBodyFirstModeLogic();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { initBodyQuiz(); checkBodyQuizMode(); });
  } else {
    initBodyQuiz();
    checkBodyQuizMode();
  }
  // END BODY-RESET-V3-MARKER


  if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartQuiz);
} else {
  initCartQuiz();
}